import type { TranslationKey } from "../index";

export const zh: Record<TranslationKey, string> = {
    // --- common — short words/phrases reused verbatim across unrelated components ------------------
    "common.brandHomeAriaLabel": "SoundCheckBox — 首页",
    "common.close": "关闭",
    "catalogCard.open": "目录卡片",
    "catalogCard.openAlternatives": "备选项的目录卡片",
    "catalogCard.alternatives": "备选项",
    "catalogCard.type": "类型",
    "catalogCard.category": "类别",
    "catalogCard.weight": "重量",
    "catalogCard.power": "功率",
    "about.heading": "关于此版本",
    "about.web": "网页",
    "about.api": "API",
    "about.schema": "架构契约",
    "about.unknown": "未知",
    "about.unstamped": "未标记的构建",
    "about.envProduction": "生产环境",
    "about.envNotProduction": "{env} — 非生产环境",
    "about.mismatch": "网页包与 API 来自不同的提交。部署只完成了一半：您看到的和响应您的不是同一份代码。",
    "common.cancel": "取消",
    "common.delete": "删除",
    "ridersList.deletePublished.heading": "该 rider 已发布",
    "ridersList.deletePublished.body": "删除会同时关闭它的公开链接。持有该链接的人——场地方、租赁公司、扫过打印二维码的人——将无法再打开，并且无法恢复。",
    "ridersList.deletePublished.dontAskAgain": "本次会话内不再询问",
    "common.deletePermanentlyPrompt": "确定要永久删除吗？",
    "common.yesDelete": "是的，删除",
    "common.loading": "加载中…",
    "common.saving": "保存中…",
    "common.sending": "发送中…",

    // --- side-nav (components/side-nav.ts) ----------------------------------------------------------
    "sideNav.home": "首页",
    "sideNav.soundman": "音响师",
    "sideNav.soundmanComingSoon": "音响师 — 即将推出",
    "sideNav.myRiders": "我的 Rider",
    "sideNav.offers": "报价",
    "myEquipment.warehouse.heading": "我的仓库",
    "myEquipment.warehouse.search": "搜索我的仓库",
    "myEquipment.warehouse.add": "添加到我的仓库",
    "myEquipment.warehouse.formed": "我的仓库已建好 — 报价时优先从中推荐",
    "myEquipment.backToOffer": "← 返回报价",
    "myEquipment.fromOffer.line": "来自 {offer}（技术需求 {rider}），已添加到您的仓库：{items}。",
    "myEquipment.fromOffer.grow": "扩充您的仓库：",
    "myEquipment.fromOffer.pick": "从我们的目录中选择",
    "myEquipment.fromOffer.import": "导入您的清单",
    "myEquipment.fromOffer.dismiss": "隐藏",
    "myEquipment.weight.notSpecified": "未注明",
    "myEquipment.col.manufacturer": "制造商",
    "myEquipment.sort.by": "排序方式",
    "myEquipment.sort.category": "类别",
    "myEquipment.more": "更多",
    "myEquipment.searchClose": "关闭搜索",
    "sideNav.inbox": "收件箱",
    "sideNav.inboxComingSoon": "收件箱 — 即将推出",
    "sideNav.outbox": "发件箱",
    "sideNav.outboxComingSoon": "发件箱 — 即将推出",
    "sideNav.eventManager": "活动策划",
    "sideNav.eventManagerComingSoon": "活动策划 — 即将推出",
    "sideNav.warehouse": "设备仓库",
    "sideNav.warehouseComingSoon": "设备仓库 — 即将推出",
    "sideNav.myProfile": "个人资料",
    "sideNav.admin": "管理",
    "sideNav.designThemeLabel": "界面主题",
    "sideNav.languageLabel": "语言",
    "sideNav.mainAriaLabel": "主菜单",

    // --- app-header (components/app-header.ts) ------------------------------------------------------
    "appHeader.adminTitle": "管理员",
    "appHeader.adminBadge": "管理员",
    "appHeader.logoutTitle": "退出登录",
    "appHeader.logoutLabel": "退出",

    // --- verify-email banner (components/verify-email-banner.ts) -------------------------------------
    "verifyBanner.message": "您的邮箱尚未验证 — 在验证之前，保存、发布等操作均已禁用。",
    "verifyBanner.profileLink": "前往个人资料",
    "verifyBanner.resend": "重新发送确认邮件",
    "verifyBanner.resendSent": "已发送 ✓",
    "verifyBanner.resendFailed": "重新发送确认邮件失败 — 请在个人资料页面重试。",
    "verifyBanner.dismissAriaLabel": "关闭",

    // --- write errors shown in place of a raw API error (api/http.ts#isEmailNotVerifiedError) --------
    "errors.emailNotVerified": "请先验证您的邮箱再进行更改 — 前往个人资料页面重新发送链接。",

    // --- login (pages/login-page.ts) -----------------------------------------------------------------
    "login.hint": "登录或创建账户以构建和保存技术 Rider。",
    "login.hintRegister": "注册账号 — 只需邮箱和密码，你的工作会随你一起转移。",
    "login.emailLabel": "邮箱或用户名",
    "login.passwordLabel": "密码",
    "login.submit": "登录",
    "login.register": "注册",
    "login.consentNotice": "创建帐户即表示你同意我们的{termsLink}和{privacyLink}。",
    "login.termsLink": "使用条款",
    "login.privacyLink": "隐私政策",
    "legal.privacyTitle": "隐私政策",
    "legal.termsTitle": "使用条款",
    "legal.unavailable": "无法加载该文档，请稍后重试。",
    "consent.title": "请查看我们的条款",
    "consent.body": "若要继续使用 SoundCheckBox，请同意我们的{termsLink}和{privacyLink}。",
    "consent.changeNote": "我们可能会更新这些文件。如果你不同意某项变更，可以停止使用本服务。",
    "consent.agree": "我同意",
    "consent.decline": "退出登录",
    "consent.saveFailed": "无法记录你的同意，请重试。",
    "editor.publishConfirm": "该 rider 将通过公开链接发布，任何人无需帐户即可打开，并在你取消发布前一直可用。其中的所有内容，包括姓名、电话和电子邮箱，也将公开。确定发布吗？",
    "editor.publishImpact.offer": "该技术文件正处于尚未达成一致的报价中（{shows}）。发布新版本将改变该报价——供应商需要重新回复变更的条目。确认发布？",
    "editor.publishImpact.contract": "该技术文件处于已达成一致的报价之下（{shows}）。未更改演出合同前不能在那里修改：供应商须确认差异，现场团队将看到新版本。确认发布？",
    "editor.publishImpact.unnamedShow": "未命名的演出",
    "editor.unpublishConfirm": "取消发布会使该 rider 的所有公开链接全部失效——包括本版本和此前的每一个版本，已经收到链接的人将无法再打开。此操作不可撤销：重新发布会生成一个新链接。确定取消发布吗？",
    "editor.publishDirty.heading": "发布未保存的更改？",
    "editor.publishDirty.body": "发布使用的是此 rider 最后保存的版本，而您最近的更改尚未保存。请先保存，才能发布这些更改。",
    "editor.publishDirty.saveAndPublish": "保存并发布",
    "login.minAge": "创建帐户须年满 16 周岁。",
    "admin.title": "管理控制台",
    "admin.notAvailable": "此页面仅供管理员使用。",
    "admin.users.title": "用户",
    "admin.users.searchPlaceholder": "按邮箱或登录名搜索",
    "admin.users.searchBtn": "搜索",
    "admin.users.showAdmins": "显示管理员",
    "admin.users.browseAll": "浏览全部",
    "admin.users.prevPage": "上一页",
    "admin.users.nextPage": "下一页",
    "admin.users.pageOf": "第 {page} / {pages} 页 — 共 {total} 个账户",
    "admin.users.searchTooShort": "请至少输入 2 个字符。",
    "admin.users.noMatch": "没有匹配的帐户。",
    "admin.users.colEmail": "邮箱",
    "admin.users.colLogin": "登录名",
    "admin.users.colJoined": "注册时间",
    "admin.users.colVerified": "已验证",
    "admin.users.colAdmin": "管理员",
    "admin.users.colActions": "操作",
    "admin.users.verify": "标记为已验证",
    "admin.users.grantAdmin": "设为管理员",
    "admin.users.revokeAdmin": "撤销管理员",
    "admin.users.verified": "邮箱已标记为已验证。",
    "admin.users.granted": "已授予管理员权限。",
    "admin.users.revoked": "已撤销管理员权限。",
    "admin.users.confirmGrant": "确定授予 {user} 管理员权限吗？",
    "admin.users.confirmRevoke": "确定撤销 {user} 的管理员权限吗？",
    "admin.users.deletionPending": "已申请删除",
    "admin.users.tempPassword": "临时密码",
    "admin.users.tempPasswordPending": "临时密码",
    "admin.users.confirmTempPassword": "为 {user} 签发临时密码？其当前密码将立即失效。",
    "admin.users.tempPasswordIssued": "{user} 的临时密码。请立即复制，之后无法再次显示：",
    "admin.users.tempPasswordDone": "临时密码已签发。",
    // --- users tab: sort, filters, summary (SCRUM-570) ---
    "admin.users.colLastLogin": "最近登录",
    "admin.users.colRiders": "Rider 数",
    "admin.users.colLastRiderEdit": "最近编辑 rider",
    "admin.users.sortBy": "按“{column}”排序",
    "admin.users.noLoginRecorded": "未记录。登录自 2026 年 10 月起才开始记录，此前没有保存，所以这个破折号并不表示该账户从未使用过。",
    "admin.users.noRiderEdit": "该账户没有 rider，因此没有编辑记录。",
    "admin.users.filtersTitle": "筛选",
    "admin.users.filterAll": "全部",
    "admin.users.filterRole": "角色",
    "admin.users.filterRoleUsers": "用户",
    "admin.users.filterRoleAdmins": "管理员",
    "admin.users.filterVerified": "邮箱已验证",
    "admin.users.filterVerifiedYes": "已验证",
    "admin.users.filterVerifiedNo": "未验证",
    "admin.users.filterRiders": "Rider",
    "admin.users.filterRidersWith": "有 rider",
    "admin.users.filterRidersWithout": "没有 rider",
    "admin.users.filterActiveDays": "最近 … 天内编辑过 rider",
    "admin.users.filterJoinedDays": "最近 … 天内注册",
    "admin.users.filterAnyDays": "不限",
    "admin.users.clearFilters": "清除筛选",
    "admin.stats.title": "汇总",
    "admin.stats.filteredHint": "数字统计的是符合上方筛选条件的账户。",
    "admin.stats.unfilteredHint": "数字统计的是全部账户。",
    "admin.stats.total": "账户",
    "admin.stats.admins": "管理员",
    "admin.stats.verified": "已验证",
    "admin.stats.withRiders": "有 rider",
    "admin.stats.ridersTotal": "Rider 总数",
    "admin.stats.windowHeader": "最近…",
    "admin.stats.days7": "7 天",
    "admin.stats.days30": "30 天",
    "admin.stats.days90": "90 天",
    "admin.stats.days365": "365 天",
    "admin.stats.activeRiderAuthors": "编辑过 rider",
    "admin.stats.newUsers": "注册",
    "admin.stats.loggedIn": "登录过",
    "admin.stats.loginNote": "登录自 2026 年 10 月起才开始记录。“登录过”一行从那天起计数，之前的会话不包含在内。",
    "admin.erasure.title": "待删除的账户",
    "admin.erasure.hint": "等待期已过的删除请求。系统不会自动删除：删除不可撤销，会连同账户的全部 Rider 一并清除。",
    "admin.erasure.none": "暂无待处理项。",
    "admin.erasure.colRequested": "申请时间",
    "admin.erasure.colDue": "到期时间",
    "admin.erasure.erase": "删除",
    "admin.erasure.confirmPrompt": "输入 {user} 以删除该账户及其全部 Rider。此操作无法撤销。",
    "admin.erasure.confirmMismatch": "地址不匹配——未删除任何内容。",
    "admin.erasure.erased": "{user} 已删除。",
    "admin.content.legalTitle": "法律文件",
    "admin.content.legalHint": "替换随站点发布的文件。留空则使用仓库中的文件，与此前一致。使用 Markdown。",
    "admin.content.mailTitle": "邮件文案",
    "admin.content.mailHint": "按语言替换邮件中的单条文案。输入框内即为当前生效的文案，可直接修改。原样保存则保持发布版；点击「还原」放弃你的修改。花括号中的占位符必须原样保留——发送时会填入实际内容。",
    "admin.content.localeLabel": "语言",
    "admin.content.usingFile": "发布版",
    "admin.content.edited": "已在此修改",
    "admin.content.legalPlaceholder": "留空——站点显示仓库中的文件。",
    "admin.content.colKey": "键",
    "admin.content.colText": "文案",
    "admin.content.save": "保存",
    "admin.content.revert": "还原",
    "admin.content.saved": "已保存。",
    "admin.content.reverted": "已还原为发布版。",
    "admin.content.confirmRevert": "放弃此修改并还原为发布版文件？",
    "admin.content.uiTitle": "界面文案",
    "admin.content.uiHint": "按语言替换界面中的单条文案，无需重新构建。输入框内即为当前生效的文案，可直接修改。原样保存则保持发布版；点击「还原」放弃你的修改。刷新页面后对所有人生效。",
    "admin.content.uiSearchPlaceholder": "按键或文本搜索",
    "admin.content.uiEditedOnly": "仅已修改",
    "admin.content.uiStart": "输入内容进行搜索，或勾选“仅已修改”。",
    "admin.content.uiTooMany": "共 {count} 条，仅显示前 200 条。请缩小搜索范围。",
    "admin.content.badPlaceholders": "未知占位符：{list}。它们会被原样输出。",
    "admin.content.savedReload": "已保存。刷新页面即可看到。",
    "admin.tabs.users": "账户",
    "admin.tabs.content": "文案",
    "admin.tabs.settings": "设置",
    "admin.content.history": "历史版本",
    "admin.content.noHistory": "暂无历史版本。",
    "admin.content.restore": "载入此版本",
    "admin.content.restoredIntoEditor": "已载入编辑器——确认后保存。",
    "admin.settings.title": "站点设置",
    "admin.settings.hint": "更改立即生效。未覆盖的设置将使用代码内置的值。",
    "admin.settings.save": "保存",
    "admin.settings.reset": "恢复默认",
    "admin.settings.saved": "已保存 {key}。",
    "admin.settings.wasReset": "{key} 已恢复为默认值。",
    "admin.settings.overridden": "已更改（默认：{default}）",
    "admin.settings.isDefault": "默认",
  "admin.models.title": "未使用的 3D 模型",
  "admin.models.hint": "没有任何预设和已保存 rider 引用的已上传 .glb 文件。删除不可撤销——没有可供恢复的上传历史。",
  "admin.models.scan": "扫描",
  "admin.models.scanning": "扫描中…",
  "admin.models.none": "无需清理——所有已上传的模型都在使用中。",
  "admin.models.summary": "未使用 {count} 个，共 {size}。仍在使用 {inUse} 个。已扫描 {presets} 个预设和 {riders} 个 rider。",
  "admin.models.colFile": "文件",
  "admin.models.colSize": "大小",
  "admin.models.colModified": "上传时间",
  "admin.models.deleteSelected": "删除所选",
  "admin.models.deleteSelectedCount": "删除所选（{count}）",
  "admin.models.confirmDelete": "确定永久删除 {count} 个模型文件？此操作无法撤销。",
  "admin.models.deleted": "已删除 {count} 个文件，释放 {size}。",
  "admin.models.skipped": "跳过 {count} 个——它们现已被引用。",
    "login.forgotPassword": "忘记密码？",
    "login.sessionExpired": "您的登录已过期，请重新登录。",
    "login.invalidCredentials": "邮箱/用户名或密码不正确。",

    // --- recovery (pages/recovery-pages.ts) -----------------------------------------------------------
    "recovery.forgotTitle": "重置密码",
    "recovery.forcedTitle": "设置你自己的密码",
    "recovery.forcedLead": "你使用的是客服签发的密码。请设置自己的密码后继续——在此之前其他功能均不可用。",
    "recovery.forcedCurrentLabel": "临时密码",
    "recovery.forcedSubmit": "保存密码",
    "recovery.forgotLead": "请输入您的邮箱，我们将向您发送重置密码的链接。",
    "recovery.emailLabel": "邮箱",
    "recovery.forgotSubmit": "发送重置链接",
    "recovery.backToSignIn": "返回登录",
    "recovery.forgotSuccess": "如果该邮箱已注册，重置链接已发送。请检查您的收件箱和垃圾邮件文件夹。",
    "recovery.resetIncompleteTitle": "重置链接不完整",
    "recovery.resetIncompleteLead": "此链接缺少验证令牌。请重新请求新链接。",
    "recovery.resetAgainLink": "请求新的重置链接",
    "recovery.resetTitle": "选择新密码",
    "recovery.newPasswordLabel": "新密码",
    "recovery.repeatPasswordLabel": "重复新密码",
    "recovery.resetSubmit": "设置新密码",
    "recovery.passwordMismatch": "两次输入的密码不一致。",
    "recovery.resetSuccess": "密码已更新。正在跳转至登录页面…",
    "recovery.verifyTitle": "确认您的邮箱",
    "recovery.verifyChecking": "正在验证链接…",
    "recovery.continueToSignIn": "继续登录",
    "recovery.verifyNoToken": "此链接缺少令牌。请从您的个人资料页面重新请求。",
    "recovery.verifySuccess": "您的邮箱已确认。您现在可以登录了。",
    "recovery.verifyFailed": "此确认链接无效或已过期。请登录并从个人资料页面请求新链接。",
    "recovery.verifyChangeTitle": "确认您的新邮箱",
    "recovery.verifyChangeNoToken": "此链接缺少令牌。请从您的个人资料页面重新请求。",
    "recovery.verifyChangeSuccess": "您的新邮箱地址已确认 — 从现在起请使用它登录。",
    "recovery.verifyChangeFailed": "此确认链接无效或已过期。请登录并在个人资料页面重新申请更改邮箱。",

    // --- landing (pages/landing-page.ts) --------------------------------------------------------------
    "landing.nav.try": "在线体验",
    "landing.nav.eventManager": "活动策划",
    "landing.nav.rentCompany": "租赁公司",
    "landing.nav.soundman": "音响工程师",
    "landing.nav.howItWorks": "工作原理",
    "landing.nav.contacts": "联系我们",
    "landing.nav.myRiders": "我的 Rider",
    "landing.nav.login": "登录",
    "landing.nav.signup": "免费注册",
    "landing.hero.title": "打造您的专属演出",
    "landing.hero.sub": "演出设备在线配置服务。构建包含全部细节的技术 Rider，一键获取租赁公司报价。",
    "landing.hero.cta": "打开编辑器",
    "landing.hero.mediaAlt": "SoundCheckBox 3D Rider 编辑器",
    "landing.try.title": "立即创建 Rider",
    "landing.try.lead": "无需账户。编辑器立即打开，您的成果保存在此浏览器中 — 只有保存、分享或发送时才需要账户。",
    "landing.try.cta": "打开编辑器",
    "landing.eventManager.title": "面向活动策划/主办方",
    "landing.eventManager.body":
        "管理音乐节、巡演、企业活动或私人演出？SoundCheckBox 是您的得力助手，集中管理乐队与租赁公司的协议。",
    "landing.eventManager.feature1Title": "设备匹配",
    "landing.eventManager.feature1Desc": "将 Rider 中的每个需求与供应商实际库存精准匹配。",
    "landing.eventManager.feature2Title": "方案对比",
    "landing.eventManager.feature2Desc": "直观对比多方报价，无需频繁反复收发邮件。",
    "landing.eventManager.feature3Title": "协议跟踪",
    "landing.eventManager.feature3Desc": "合作前即可查看公司信誉与历史演出评价。",
    "landing.eventManager.feature4Title": "便捷支付",
    "landing.eventManager.feature4Desc": "无需离开平台即可一站式结算预订费用。",
    "landing.eventManager.mediaAlt": "活动策划工作流程",
    "landing.rentCompany.title": "面向设备租赁公司",
    "landing.rentCompany.body":
        "自动化管理助手：解析传入的 Rider，对比您的仓库库存，并自动生成报价。",
    "landing.rentCompany.feature1Title": "库存匹配",
    "landing.rentCompany.feature1Desc": "根据您的真实仓库库存比对 Rider 需求。",
    "landing.rentCompany.feature2Title": "自动定价",
    "landing.rentCompany.feature2Desc": "在收到 Rider 的瞬间，根据您的费率自动计算价格。",
    "landing.rentCompany.feature3Title": "大型运营支持",
    "landing.rentCompany.feature3Desc": "专为大容量设备管理打造，支持自定义软件对接。",
    "landing.rentCompany.feature4Title": "转租协调",
    "landing.rentCompany.feature4Desc": "缺少某项设备？系统将直接指引您向有存货的公司转租。",
    "landing.rentCompany.mediaAlt": "租赁公司工作流程",
    "landing.soundman.title": "面向音响师/调音师",
    "landing.soundman.body":
        "减少文书繁琐，留出更多时间做音乐。从成熟搭建方案开始，为您服务的每支乐队复用预设。",
    "landing.soundman.feature1Title": "成熟方案",
    "landing.soundman.feature1Desc": "直接在可用的舞台布局上修改，无需从零开始。",
    "landing.soundman.feature2Title": "专属预设",
    "landing.soundman.feature2Desc": "保存一次自定义设备组合，随时拖拽复用。",
    "landing.soundman.feature3Title": "多乐队管理",
    "landing.soundman.feature3Desc": "在一个账户中集中管理您负责的所有乐队。",
    "landing.soundman.feature4Title": "套餐建议",
    "landing.soundman.feature4Desc": "租赁公司可针对您的 Rider 直接提交完整配套方案。",
    "landing.soundman.mediaAlt": "音响师工作流程",
    "landing.howItWorks.videoTitle": "SoundCheckBox — 演示视频",
    "landing.howItWorks.lead":
        "在 3D 舞台上布置设备，通道表、输出表和设备清单即可实时自动生成。可直接打印或发送给租赁公司。",
    "landing.howItWorks.feature1Title": "1. 搭建舞台",
    "landing.howItWorks.feature1Desc": "将爵士鼓、乐器箱体、话筒、返送等预设拖拽至等比例舞台。",
    "landing.howItWorks.feature2Title": "2. 自动生成清单",
    "landing.howItWorks.feature2Desc": "通道、信号源和设备将根据舞台摆放自动推导。",
    "landing.howItWorks.feature3Title": "3. 轻松分享",
    "landing.howItWorks.feature3Desc": "打印包含舞台布局图的整洁 A4 Rider，或直接发送给供应商。",
    "landing.contact.title": "联系我们",
    "landing.contact.emailLabel": "邮箱",
    "landing.contact.addressLabel": "地址",
    "landing.contact.followUs": "关注我们",
    "landing.contact.nameFieldLabel": "您的姓名",
    "landing.contact.emailFieldLabel": "您的邮箱",
    "landing.contact.messageLabel": "留言内容",
    "landing.contact.submit": "发送留言",
    "landing.contact.captchaNote": "受 Cloudflare Turnstile 保护 — 适用于 Cloudflare 的 {privacyLink} 和 {termsLink}。",
    "landing.contact.privacyPolicyLinkText": "隐私政策",
    "landing.contact.termsLinkText": "服务条款",
    "landing.contact.validationError": "请填写您的姓名、邮箱和留言内容。",
    "landing.contact.success": "感谢您的留言 — 消息已发送。我们会回复至您提供的邮箱。",
    "landing.footer.tagline": "SoundCheckBox — 技术 Rider 编辑构建工具",

    // --- riders list (pages/riders-list-page.ts) ------------------------------------------------------
    "riders.pageTitle": "我的 Rider",
    "riders.newRiderButton": "新建 Rider",
    "riders.filter.groupLabel": "按状态筛选 Rider",
    "riders.filter.all": "全部",
    "riders.filter.empty": "没有符合此筛选条件的 Rider。",
    "riders.table.title": "名称",
    "riders.table.band": "乐队 / 艺人",
    "riders.table.created": "创建时间",
    "riders.table.changed": "修改时间",
    "riders.table.status": "状态",
    "riders.table.action": "操作",
    "riders.table.empty": "暂无 Rider — 点击“+ 新建 Rider”创建您的第一个作品。",
    "riders.status.published": "已发布",
    "riders.status.draft": "草稿",
    "riders.status.publicLinkTitle": "公开链接: {url}",
    "riders.actions.edit": "编辑",
    "riders.actions.moreActionsAriaLabel": "针对 {title} 的更多操作",
    "riders.actions.publish": "发布",
    "riders.actions.unpublish": "取消发布",
    "riders.actions.print": "打印",
    "riders.actions.copyPublicLink": "复制公开链接",
    "riders.actions.rename": "重命名",
    "riders.actions.duplicate": "创建副本",
    "riders.copySuffix": "(副本)",
    "riders.copySuffixN": "(副本 {n})",
    "riders.rename.heading": "重命名技术需求单",
    "riders.rename.nameLabel": "新名称",
    "riders.rename.confirm": "重命名",
    "riders.status.renaming": "正在重命名“{title}”…",
    "riders.status.renamed": "已重命名为“{title}”。",
    "riders.status.renameFailed": "无法重命名“{title}”：{message}",
    "riders.status.duplicating": "正在创建“{title}”的副本…",
    "riders.status.duplicated": "已创建“{title}”。",
    "riders.status.duplicateFailed": "无法创建“{title}”的副本：{message}",
    "riders.status.deleting": '正在删除 "{title}"…',
    "riders.status.deleted": '已删除 "{title}"。',
    "riders.status.deleteFailed": '删除 "{title}" 失败: {message}',
    "riders.status.linkCopied": "公开链接已复制: {url}",
    "riders.status.unpublished": '已取消发布 "{title}"。',
    "riders.status.publishSuccess": '已发布 "{title}" — 公开链接: {url}',
    "riders.status.unpublishFailed": '取消发布 "{title}" 失败: {message}',
    "riders.status.publishFailed": '发布 "{title}" 失败: {message}',
    "riders.status.publishedNoPicture": "公开页面没有舞台平面图：此列表无法绘制。请从编辑器发布以添加。",
    "riders.status.loading": "正在加载您的 Rider…",
    "riders.status.loadFailed": "加载 Rider 失败: {message}",

    // --- profile (pages/profile-page.ts) ---------------------------------------------------------------
    "profile.pageTitle": "个人资料",
    "profile.personal.title": "个人信息",
    "profile.personal.nameLabel": "姓名",
    "profile.personal.phoneLabel": "电话",
    "profile.personal.countryLabel": "国家",
    "profile.personal.cityLabel": "城市",
    "profile.personal.languageLabel": "界面语言",
    "profile.personal.save": "保存个人信息",
    "profile.work.title": "工作信息",
    "profile.work.companyLabel": "公司 / 团队",
    "profile.work.roleLabel": "我的身份",
    "roleChoice.hint": "决定登录后打开哪个页面。",
    "roleChoice.hintOptional": "可选。决定登录后打开哪个页面。",
    "profile.work.role.soundman": "音响工程师",
    "profile.work.role.manager": "活动策划",
    "profile.work.role.rental": "租赁公司",
    "profile.work.role.other": "其他",
    "profile.work.save": "保存工作信息",
    "profile.defaults.title": "Rider 默认设置",
    "profile.defaults.hint": "这些信息将预填到每个新 Rider 的联系人模块中。每个 Rider 会保留各自最终保存的值。",
    "profile.defaults.bandNameLabel": "乐队名称",
    "profile.defaults.contactNameLabel": "联系人姓名",
    "profile.defaults.contactPhoneLabel": "联系电话",
    "profile.defaults.contactEmailLabel": "联系邮箱",
    "profile.defaults.save": "保存 Rider 默认设置",
    "profile.security.title": "安全设置",
    "profile.security.emailLabel": "邮箱",
    "profile.security.emailConfirmedLabel": "邮箱已验证",
    "profile.security.passwordChangedLabel": "上次修改密码",
    "profile.security.memberSinceLabel": "注册时间",
    "profile.security.emailVerifiedYes": "是",
    "profile.security.emailVerifiedNot": "未验证",
    "profile.security.resendVerification": "重新发送确认邮件",
    "profile.security.changePasswordTitle": "修改密码",
    "profile.security.changePasswordSubmit": "确认修改密码",
    "profile.security.currentPasswordLabel": "当前密码",
    "profile.security.newPasswordLabel": "新密码",
    "profile.security.repeatPasswordLabel": "重复新密码",
    "profile.security.resendSent": "已发送 ✓",
    "profile.security.resendSuccess": "确认邮件已发送。请检查您的收件箱和垃圾邮件文件夹。",
    "profile.security.passwordMismatch": "两次输入的新密码不一致。",
    "profile.security.passwordChanged": "密码已修改。我们已向您的邮箱发送了确认信。",
    "profile.security.changeEmailTitle": "更改邮箱",
    "profile.security.changeEmailHint": "我们会向新地址发送确认链接 — 在您点击之前不会有任何更改。",
    "profile.security.newEmailLabel": "新邮箱",
    "profile.security.currentPasswordForEmailLabel": "当前密码",
    "profile.security.changeEmailSubmit": "发送确认链接",
    "profile.security.changeEmailMissingFields": "请输入新邮箱地址和您的当前密码。",
    "profile.security.changePasswordMissingFields": "请输入当前密码和至少 8 个字符的新密码。",
    "profile.security.changeEmailSuccess": "如果 {newEmail} 尚未被占用，确认链接已发送至该邮箱。请查收收件箱和垃圾邮件文件夹。",
    "profile.security.changeEmailPending": "我们已向 {newEmail} 发送了确认链接。在确认之前，您仍以 {currentEmail} 身份登录。",
    "profile.ai.title": "AI 助手",
    "profile.ai.hint": "助手有少量免费额度。用完后，添加你自己的 Google Gemini 密钥即可继续使用——直接向 Google 付费，此处无限制。",
    "profile.ai.usageFree": "免费额度已用：{used} / {cap}。",
    "profile.ai.usageByok": "正在使用你的密钥（{hint}）——无限制。",
    "profile.ai.byokHint": "粘贴你自己的 Gemini API 密钥，在免费额度用完后继续使用助手。",
    "profile.ai.getKeyLink": "获取免费密钥",
    "profile.ai.keyLabel": "你的 Gemini API 密钥",
    "profile.ai.keyReplace": "输入新密钥以替换",
    "profile.ai.saveKey": "保存密钥",
    "profile.ai.clearKey": "移除密钥",
    "profile.ai.byokUnavailable": "此服务器暂不支持使用自带密钥。",
    "profile.ai.keyRequired": "请先输入你的 API 密钥。",
    "profile.ai.keyValidating": "正在校验密钥……",
    "profile.ai.keySaved": "密钥已保存——助手现在使用它。",
    "profile.ai.keyCleared": "密钥已移除。",
    "profile.ai.keySaveFailed": "无法保存密钥：{message}",
    "profile.ai.loadFailed": "无法加载你的 AI 使用情况。",
    "profile.privacy.title": "数据与隐私",
    "profile.privacy.hint": "您在 GDPR 及相关法律下的隐私权利。",
    "profile.privacy.downloadTitle": "下载我的数据",
    "profile.privacy.downloadHint": "包含您所有 Rider 在内的完整存储数据导出为一个 JSON 文件。",
    "profile.privacy.downloadButton": "下载数据",
    "profile.privacy.marketingTitle": "产品资讯",
    "profile.privacy.marketingHint":
        "偶尔发送关于 SoundCheckBox 的更新资讯。服务通知邮件（重置密码、确认邮件）将始终正常发送。",
    "profile.privacy.marketingCheckbox": "接收产品资讯邮件",
    "profile.privacy.deleteTitle": "删除我的账户",
    "profile.privacy.deleteHint": "永久注销您的账户并删除您拥有的所有 Rider。",
    "profile.privacy.deleteButton": "注销账户",
    "profile.privacy.cancelDeleteButton": "取消注销",
    "profile.status.loadFailed": "无法加载您的个人资料: {message}",
    "profile.status.personalSaved": "个人信息已保存。",
    "profile.status.workSaved": "工作信息已保存。",
    "profile.status.defaultsSaved": "Rider 默认设置已保存。",
    "profile.privacy.preparingExport": "正在准备您的数据…",
    "profile.privacy.exportDownloaded": "您的数据文件已下载。",
    "profile.privacy.marketingOn": "您将接收产品资讯邮件。",
    "profile.privacy.marketingOff": "您已退订产品资讯邮件。",
    "profile.privacy.deleteConfirm":
        "确定要注销 SoundCheckBox 账户吗？\n\n宽限期过后，您的账户和所有 Rider 将被永久删除。在此之前您可以随时取消注销。",
    "profile.privacy.deletionScheduled": "注销程序已计划。详情已发送至您的邮箱 — 您仍可取消。",
    "profile.privacy.deletionCancelled": "注销已取消。您的账户保持激活状态。",
    "profile.privacy.deletionPendingHint":
        "计划于 {date} 彻底抹除。在此日期前您可以随时取消。",

    // --- public rider viewer (pages/public-viewer-page.ts) ---------------------------------------------
    "publicViewer.headerSub": "公开 Rider",
    "publicViewer.riderListsAriaLabel": "Rider 清单",
    "publicViewer.controls.grid": "网格",
    "publicViewer.controls.titles": "名称标注",
    "publicViewer.controls.inputCh": "输入通道 (CH)",
    "publicViewer.controls.outputMix": "输出线路 (MIX)",
    "publicViewer.controls.source": "音源",
    "publicViewer.controls.comments": "备注",
    "publicViewer.window.close": "关闭窗口",
    "publicViewer.window.zoomIn": "放大",
    "publicViewer.window.zoomOut": "缩小",
    "publicViewer.controls.scene": "3D 舞台",
    "publicViewer.controls.sceneLoading": "3D (加载中...)",
    "publicViewer.controls.sceneHint": "以三维方式查看舞台——拖动可环绕观察。",
    "publicViewer.controls.plan": "俯视图",
    "publicViewer.controls.planHint": "从观众席方向垂直俯视舞台。",
    "publicViewer.controls.schematic": "黑白图",
    "publicViewer.schematicLoading": "正在绘制平面图…",
    "publicViewer.schematicFailed": "无法加载符号库。",
    "publicViewer.controls.schematicHint": "用于打印和快速阅读的高对比度黑白舞台图纸。",
    "publicViewer.controls.schematicDisabledHint": "尚未就绪 — 黑白平面图仍在完善中。",
    "publicViewer.loaderAlt": "正在加载数据和3D模型...",
    "publicViewer.controls.hideStage": "隐藏舞台",
    "publicViewer.controls.showStage": "显示舞台",
    "publicViewer.controls.hideStageHint": "隐藏舞台，让列表和技术文本占满整个屏幕。",
    "publicViewer.controls.viewSwitchAriaLabel": "舞台视图",
    "publicViewer.controls.follow": "缩放到所选",
    "publicViewer.controls.followHint": "选择某个通道时，镜头会飞向对应的声源对象。",
    "publicViewer.controls.labels": "标注",
    "publicViewer.controls.fit": "全舞台",
    "publicViewer.controls.fitHint": "重新显示整个舞台。",
    "publicViewer.controls.print": "打印",
    "publicViewer.stageHint": "拖拽旋转视角，双指缩放/滚轮缩放，点击对象以选中。",
    "publicViewer.stageHintPlan": "拖拽平移平面图，双指缩放/滚轮缩放，点击对象以选中。",
    "publicViewer.planPosterAlt": "发布此巡演要求时渲染的舞台俯视图",
    "publicViewer.deselectAriaLabel": "取消选择",
    "publicViewer.tabs.rider": "Rider 信息",
    "publicViewer.tabs.input": "输入表",
    "publicViewer.tabs.output": "输出表",
    "publicViewer.tabs.gear": "设备清单",
    "publicViewer.bandLogoAlt": "乐队 Logo",
    "publicViewer.table.ch": "通道",
    "publicViewer.table.source": "音源",
    "publicViewer.table.type": "类型",
    "publicViewer.table.name": "名称",
    "publicViewer.table.comment": "备注",
    "publicViewer.table.category": "分类",
    "publicViewer.table.owner": "归属",
    "publicViewer.table.count": "数量",
    "publicViewer.footer": "基于",
    "publicViewer.meta.inputCh": "输入通道 (CH)",
    "publicViewer.meta.outputMix": "输出混合 (MIX)",
    "publicViewer.meta.gear": "设备清单",
    "publicViewer.meta.gearCount": "{n} 件",
    "publicViewer.noRiderNotes": "暂无 Rider 备注。",
    "publicViewer.untitledRiderHeading": "未命名 Rider",
    "publicViewer.untitledRiderDocTitle": "Rider",
    "publicViewer.documentTitle": "{title} — SoundCheckBox",
    "publicViewer.contactLabel": "联系人: {name}",
    "publicViewer.telLabel": "电话: {phone}",
    "publicViewer.emailLabel": "邮箱: {email}",
    "publicViewer.status.noRiderId": "未指定 Rider — 链接缺少 ID 参数。",
    "publicViewer.status.withdrawn": "作者已撤回该 rider，此链接不再有效。",
    "common.deletePublishedPrompt": "永久删除？所有持有该公开链接的人都将无法再打开它。",
    "common.yesDeleteAndUnpublish": "是的，删除并关闭链接",
    "publicViewer.status.notPublished": "该 Rider 尚未发布（或不存在）。请联系创建者进行发布。",
    "publicViewer.powerUnavailable": "功率统计不可用。",
    "publicViewer.controls.makeOffer": "提交报价",
    "publicViewer.controls.makeOfferHint": "以供应商身份回复此 Rider 的通道与设备清单。",
    "publicViewer.controls.compact": "紧凑视图",
    "publicViewer.controls.compactHint": "黑白平面图，下方是简短的通道列表。",
    "publicViewer.controls.io": "I/O",
    "publicViewer.controls.ioHint": "在平面图上显示通道和混音编号。",
    "publicViewer.controls.more": "更多",
    "publicViewer.controls.loadingWord": "(加载中...)",
    "publicViewer.phantomTitle": "幻象供电 (+48V)",
    "publicViewer.planFull.ariaLabel": "全屏打开平面图",
    "publicViewer.status.offerOwnRider": "不能对自己的 Rider 提交报价。",
    "publicViewer.status.offerStartFailed": "无法开始报价：{error}",

    // --- offer mode (pages/offer-overlay.ts, PR2 — docs/V2_OFFER_TECH_APPROVAL.md) -----------------------
    "offer.loading": "正在加载报价…",
    "offer.loadFailed": "无法加载该报价：{error}",
    "offer.backToRider": "返回 Rider",
    "offer.status.draft": "草稿",
    "offer.status.submitted": "已提交",
    "offer.status.changesRequested": "已要求修改",
    "offer.status.awaitingOrganiser": "等待主办方",
    "offer.status.approved": "已批准",
    "offer.roundLabel": "回复 v{n}",
    "offer.commentLabel": "总体说明",
    "offer.commentPlaceholder": "Rider 作者应该了解的关于此报价整体的任何信息…",
    "offer.authorCommentHeading": "Rider 作者要求修改",
    "offer.declinedReasonHeading": "Rider 作者给出的拒绝原因",
    "offer.markRemainingOk": "将其余标记为 OK",
    "offer.saveDraft": "保存草稿",
    "offer.submit": "提交报价",
    "offer.saving": "正在保存…",
    "offer.savedStatus": "草稿已保存。",
    "offer.submitting": "正在提交…",
    "offer.submitFailed": "提交失败：{error}",
    "offer.saveFailed": "保存失败：{error}",
    "offer.printFailed": "打印失败：{error}",
    "offer.guest.notice": "您尚未登录。在您发送报价之前，答案会保存在此浏览器中。",
    "offer.myList.button": "与我的仓库核对",
    "offer.myList.empty": "您的仓库为空 — 请在“设备仓库”中添加设备",
    "offer.myList.link": "设备仓库",
    "offer.myList.summary": "根据您的清单，{ok} 行可标记为 OK，{short} 行您的数量不足，{missing} 行不在您的清单中",
    "offer.myList.apply": "应用",
    "offer.myList.cancel": "取消",
    "offer.myList.short": "您有 {have}/{need}",
    "offer.myList.marker": "来自我的清单",
    "offer.myList.nothing": "无需核对：所有设备行都已有答复。",
    "offer.guest.signInStep": "要发送报价，请登录或创建账户——您的答案会被保留。",
    "offer.guest.signInButton": "登录或创建账户",
    "offer.guest.keepEditing": "继续编辑",
    "offer.guest.emailLabel": "您的邮箱",
    "offer.guest.emailSend": "发送报价",
    "offer.guest.emailHint": "我们会把链接发到您的邮箱。打开链接，报价即发送，无需密码。",
    "offer.guest.emailInvalid": "请输入有效的邮箱地址。",
    "offer.guest.emailSent": "我们已向 {email} 发送邮件。打开其中的链接，报价将自动发送。您可以关闭此标签页；您的回答会在此浏览器中保留 48 小时。",
    "offer.guest.emailSendFailed": "暂时无法发送邮件。请一分钟后再试。",
    "offer.guest.emailAlreadySent": "确认邮件已发送至 {email}。打开其中的链接，报价将自动发送。也请查看垃圾邮件文件夹：来自陌生发件人的邮件常被放到那里。如果没有，请在 {minutes} 分钟后再次请求。",
    "offer.guest.emailSentAgain": "确认邮件已发送至 {email}，我们又发送了一次。打开任意一封邮件中的链接，报价将自动发送。也请查看垃圾邮件文件夹：来自陌生发件人的邮件常被放到那里。",
    "offer.autoSending": "正在发送报价…",
    "offer.autoSent": "您的报价已发送。",
    "offer.awaitingEmail": "我们已向 {email} 发送邮件。打开其中的链接，报价将自动发送。",
    "offer.where.title": "时间与地点——让报价进入正确的演出",
    "offer.where.dateLabel": "日期",
    "offer.where.kind.range": "时间段",
    "offer.where.kind.choice": "多个日期",
    "offer.where.kind.day": "单日",
    "offer.where.pick.day": "点选一天。",
    "offer.where.pick.range": "先点开始日，再点结束日。",
    "offer.where.pick.choice": "点选每个可行的日期，至少两个。",
    "offer.where.clear": "暂无日期",
    "offer.where.prevMonth": "上个月",
    "offer.where.nextMonth": "下个月",
    "offer.where.chips": "快速选择",
    "offer.where.weekdays": "可用的星期",
    "offer.where.chip.thisWeek": "本周",
    "offer.where.chip.nextWeek": "下周",
    "offer.where.chip.lastWeekOf": "{month}最后一周",
    "offer.where.chip.wholeMonth": "整月",
    "offer.where.possibleDays": "可选天数：{n}",
    "offer.where.removeDate": "移除日期",
    "offer.where.venue": "场地",
    "offer.where.city": "城市（可选）",
    "offer.where.hint": "乐队会在其演出中看到你针对该日期的报价。",
    "offer.where.error.dayMissing": "请选择日期。",
    "offer.where.error.rangeIncomplete": "请点选时间段的最后一天。",
    "offer.where.error.rangeBackwards": "范围的结束日期早于开始日期。",
    "offer.where.error.rangeNoDays": "范围内的每一天都被划掉了——请至少勾选一个星期。",
    "offer.where.error.choiceFew": "请至少选两个日期，或切换到“单日”。",
    "offer.placed.whenVenue": "您针对这场演出（{when}, {venue}）的报价已发送，演出主办方正在审阅，谢谢！",
    "offer.placed.when": "您针对这场演出（{when}）的报价已发送，演出主办方正在审阅，谢谢！",
    "offer.placed.venue": "您针对这场演出（{venue}）的报价已发送，演出主办方正在审阅，谢谢！",
    "offer.placed.none": "您针对这场演出的报价已发送，演出主办方正在审阅，谢谢！",
    "offer.showLink.for": "针对：{parts}。",
    "offer.showLink.archived": "这场演出已经敲定，不再接受新的报价。",
    "offer.showLink.gone": "此演出链接无效——已被撤回或无法读取。请向乐队索取新链接。",
    "offer.send.title": "发送此报价？",
    "offer.send.rider": "Rider：{title}，v{version}",
    "offer.send.lines": "行数：{total}",
    "offer.send.comment": "您的总体备注",
    "offer.send.ask": "请确认：填写日期和场地，或说明尚未确定。",
    "offer.send.notSet": "日期和场地尚未确定",
    "offer.send.notSetOn": "将以此发送：日期和场地尚未确定。",
    "offer.send.or": "或",
    "offer.send.send": "发送",
    "offer.send.back": "返回报价",
    "offer.send.close": "关闭",
    "offer.send.need": "请填写日期和场地，或点按“日期和场地尚未确定”。",
    "offer.send.viaLink": "日期和场地来自演出链接——无需填写。",
    "offer.said.notSet": "日期和场地：尚未确定（供应商的回答）",
    "riders.actions.publishToShow": "发布到演出",
    "publishShow.title": "发布到演出",
    "publishShow.hint": "演出有日期和场地。打开链接的供应商将针对这场演出报价。",
    "publishShow.whenWhere": "时间与地点",
    "publishShow.rider": "Rider：{title}，v{version}",
    "publishShow.create": "创建演出和链接",
    "publishShow.creating": "正在创建演出…",
    "publishShow.linkLabel": "供应商链接",
    "publishShow.copy": "复制",
    "share.action": "发送",
    "share.hint": "通过邮件、WhatsApp、Telegram 或任意即时通讯软件发送该技术需求单",
    "share.email": "邮件",
    "share.whatsapp": "WhatsApp",
    "share.telegram": "Telegram",
    "share.copyLink": "复制链接",
    "share.copied": "链接已复制",
    "share.kind": "技术需求单",
    "publishShow.copied": "已复制",
    "publishShow.close": "关闭",
    "publishShow.notPublished": "请先发布 rider——演出指向已发布的版本。",
    "publishShow.failed": "无法创建演出：{error}",
    "showPage.about": "关于这场演出",
    "showPage.when": "日期",
    "showPage.venue": "场地",
    "showPage.rider": "Rider",
    "showPage.riderValue": "{title}，v{version}",
    "showPage.dateOpen": "日期尚未确定",
    "showPage.venueNone": "场地尚未选定",
    "showPage.makeOffer": "提交报价",
    "showPage.archived.past": "这场演出已经举行。本页是它的存档，不再接受报价。",
    "showPage.archived.agreed": "这场演出已经敲定。本页是它的存档，不再接受报价。",
    "showPage.repeat": "重复这场演出",
    "showPage.loadFailed": "无法读取这场演出：{error}",
    "repeatShow.title": "重复这场演出",
    "repeatShow.hint": "新建一场演出，场地和演出者与原来相同。原演出保持不变。",
    "repeatShow.whenWhere": "新日期",
    "repeatShow.rider.newer": "Rider 有较新的版本（v{newest}；演出时用的是 v{played}）",
    "repeatShow.rider.quiet": "自演出以来 rider 没有变化（v{played}）。",
    "repeatShow.rider.newest": "采用最新版本",
    "repeatShow.rider.keep": "沿用演出时的版本",
    "repeatShow.rider.ask": "请乐队提供新的 rider",
    "repeatShow.offers.title": "报价",
    "repeatShow.offers.count": "这场演出已批准的报价：{n}",
    "repeatShow.offers.invite": "再次邀请同一家公司",
    "repeatShow.offers.none": "不带报价开始",
    "repeatShow.create": "创建新演出",
    "repeatShow.creating": "正在创建演出…",
    "repeatShow.needAnswer": "请回答上面的问题后继续。",
    "repeatShow.done": "新演出已创建。这是给供应商的链接：",
    "repeatShow.failed": "无法重复这场演出：{error}",
    "emailLogin.title": "正在登录",
    "emailLogin.checking": "正在检查链接…",
    "emailLogin.failed": "此链接已过期或已被使用。请重新打开该技术需求单并点击发送——您的回答会在此浏览器中保留 48 小时。",
    "emailLogin.noToken": "此链接不完整。请从邮件中重新打开。",
    "emailLogin.success": "您已登录。",
    "emailLogin.offerFailed": "随您的邮箱发送的报价未能送达——该技术需求单可能已被撤回。请重新打开并再次发送。",
    "emailLogin.usedTitle": "此链接已被使用",
    "emailLogin.usedBody": "如果您用它发送过报价，报价已送达，保存在 {email} 的账户中。我们会向同一地址发送新链接：它会打开您的账户和报价，您可以在那里设置密码。",
    "emailLogin.usedBodyNoEmail": "如果您用此链接发送过报价，报价已送达。输入您的邮箱，我们会发送一个进入您账户的新链接。",
    "emailLogin.emailLabel": "您的邮箱",
    "emailLogin.sendNew": "给我发新链接",
    "emailLogin.signIn": "我已有账号——登录",
    "emailLogin.newSent": "我们已向 {email} 发送新链接。打开它，您将进入自己的账户，看到您的报价。",
    "setPassword.title": "设置密码，以便日后返回",
    "setPassword.hint": "您的账户是通过邮件中的链接创建的。设置密码后，您可以随时打开它，查看您的报价和作者的回复。",
    "setPassword.label": "新密码（至少 8 个字符）",
    "setPassword.button": "设置密码",
    "setPassword.tooShort": "密码至少需要 8 个字符。",
    "setPassword.done": "密码已设置。下次请用您的邮箱和此密码登录。",
    "setPassword.failed": "无法设置密码，请重试。",
    "offer.validation.modelRequired": "保存前请为每个「替代」答案填写型号。",
    "offer.validation.reasonRequired": "保存前请为每个「不可用」答案填写原因。",
    "offer.readOnlyNotice": "此报价状态为「{status}」，不能再编辑。",
    "offer.table.answer": "回复",
    "offer.bandBringsNote": "由乐队自带",
    "offer.gear.consumables": "耗材 — 来自已确认的套装",
    "offer.gear.cablesElsewhere": "线缆在下方的独立分区中列出。",
    "offer.notConnectedNote": "未连接",
    "offer.answer.unanswered": "—",
    "offer.answer.ok": "OK",
    "offer.answer.markOk": "确认为 OK",
    "offer.answer.substitute": "替代",
    "offer.answer.bandCarried": "乐队自带",
    "offer.answer.na": "不可用",
    "offer.answer.venueProvided": "场地提供",
    "offer.answer.modelPlaceholder": "型号",
    "offer.alt.warehouseEmpty": "此类别中您没有设备",
    "offer.alt.searchCatalogue": "在我们的目录中搜索",
    "offer.answer.reasonPlaceholder": "原因",

    "offer.answer.commentPlaceholder": "备注",
    "offer.answer.short.ok": "OK",
    "offer.answer.short.substitute": "替代",
    "offer.answer.short.bandCarried": "乐队",
    "offer.answer.short.na": "N/D",
    "offer.answer.short.venueProvided": "场地",
    "offer.collapseAll": "全部收起",
    "offer.expandAll": "全部展开",
    "offer.patchShow": "打补丁此演出 →",
    "offer.confirmedOf": "已确认 {done}/{total}",
    "offer.summary.confirmed": "已确认",
    "offer.summary.alternatives": "有替代",
    "offer.summary.unavailable": "没有",
    "offer.summary.open": "尚未回答",
    "offer.summary.nothingYet": "尚未回答任何内容",
    "offer.allConfirmed": "全部已确认",
    "offer.sectionToggle": "展开或收起此部分",
    "offer.plan.title": "舞台图",
    "offer.plan.io": "I/O",
    "offer.plan.ioShow": "显示通道和混音标注",
    "offer.plan.ioHide": "隐藏通道和混音标注",
    "offer.plan.open": "点按全屏打开",
    "offer.plan.close": "关闭",
    "offer.plan.zoomIn": "放大",
    "offer.plan.zoomOut": "缩小",
    "offer.plan.loading": "正在绘制舞台图…",
    "offer.plan.failed": "无法绘制舞台图。",
    "offer.wire.checkPatch": "检查演出补丁和线缆长度 →",
    "offer.wire.hint": "打开补丁编辑器和线缆计算",
    "offer.wire.longMic": "长话筒线",
    "offer.wire.shortPatch": "短跳线",
    "offer.detail.each": "这 {n} 件各自的用途",
    "offer.detail.kit": "套件 {name}",
    "offer.detail.kitHide": "套件 {name}",
    "offer.amp.summary": "{n} × LA4X amplified controller · {capacity} output channels · 已用 {used} · 空闲 {free}",
    "offer.amp.capacity": "每台 LA4X 的 drive capacity：2 × 115XT HiQ 或 4 × SB18 (L-Acoustics)",
    "offer.amp.channels": "{n} 通道",
    "offer.amp.twoWay": "2-way active (LF + HF)",
    "offer.amp.oneChannel": "1 output channel",
    "offer.amp.used": "{used}/{capacity} 通道",
    // --- offer review mode (pages/offer-review-overlay.ts, PR3 — docs/V2_OFFER_TECH_APPROVAL.md) -----
    "offer.review.supplierCommentLabel": "供应商备注",
    "offer.review.noComment": "无备注。",
    "offer.review.yourRequestHeading": "您要求的修改",
    "offer.review.approvedNotice": "此报价已获批准，不能再做任何修改。",
    "offer.review.approve": "批准",
    "offer.review.requestChanges": "要求修改",
    "offer.review.requestChangesCommentLabel": "需要修改什么？",
    "offer.review.requestChangesCommentPlaceholder": "告诉供应商在重新提交前需要修正什么…",
    "offer.review.sendRequest": "发送",
    "offer.review.approving": "批准中…",
    "offer.review.approveFailed": "无法批准：{error}",
    "offer.review.sending": "发送中…",
    "offer.review.requestFailed": "无法发送：{error}",
    "offer.review.commentRequired": "发送前请说明需要修改什么。",
    "offer.review.supplierNameUnknown": "未知供应商",
    "offer.review.historyHeading": "历史记录",
    "offer.review.history.submitted": "已提交",
    "offer.review.history.changesRequested": "已要求修改",
    "offer.review.history.approved": "已批准",
    "offer.status.declined": "已拒绝",
    "offer.review.decline": "拒绝",
    "offer.review.declinedNotice": "此报价已被拒绝。供应商无法修改或重新提交。",
    "offer.review.declineConfirm": "拒绝此报价？此操作为最终决定：供应商将收到通知，且无法重新提交。",
    "offer.review.declineReasonLabel": "原因（可选）",
    "offer.review.declineReasonPlaceholder": "供应商将在邮件中看到…",
    "offer.review.declineConfirmButton": "拒绝报价",
    "offer.review.declining": "正在拒绝…",
    "offer.review.declineFailed": "无法拒绝：{error}",
    "offer.review.history.declined": "已拒绝",

    // --- /offers — the two-sided offer inbox (pages/offers-page.ts, PR3) -----------------------------
    "offers.pageTitle": "报价",
    "offers.incomingHeading": "我的 Rider 收到的报价",
    "offers.mineHeading": "我发出的报价",
    "offers.incomingEmpty": "还没有人回应您发布的 Rider。",
    "offers.mineEmpty": "您还没有对任何 Rider 发出报价。",
    "offers.table.rider": "Rider",
    "offers.table.supplier": "供应商",
    "offers.table.supplierUnknown": "未知供应商",
    "offers.table.status": "状态",
    "offers.table.round": "轮次",
    "offers.table.updated": "更新时间",
    "offers.status.loading": "加载中…",
    "offers.status.loadFailed": "无法加载报价：{error}",

    // --- editor topbar (components/topbar.ts) -----------------------------------------------------------
    "topbar.loggedInAs": "当前登录: {email}",
    "topbar.adminBadge": "管理员",
    "topbar.adminBadgeTitle": "您拥有管理员权限（例如上传 3D 模型）。",
    "topbar.unsavedRiderId": "(未保存的新 Rider)",
    "topbar.save.title": "保存 Rider 至数据库 ({mod}+S)",
    "topbar.save.copyTitle":
        "保存为我的副本 — 该 Rider 属于其他人，保存将会在您的账户下创建一个新的副本 ({mod}+S)",
    "topbar.save.copyLabel": "保存为我的副本",
    "topbar.saveAs.title": "另存为…… 将当前打开的技术需求单以你指定的名称另存为一份新的，原件保持不变 ({mod}+Shift+S)",
    "topbar.saveAs.label": "另存为…",
    "topbar.attach.title": "将对象绑定至另一个对象 — 激活模式后点击目标父级",
    "topbar.attach.label": "绑定对象",
    "topbar.attach.armedTitle": "绑定模式已激活 — 请在 3D 场景中点击父级对象（按 Escape 取消）。",
    "topbar.attach.armedLabel": "选择目标对象…",
    "topbar.publish.label": "发布 Rider",
    "topbar.publish.titleUnsaved": "发布 Rider — 请先保存 Rider",
    "topbar.publish.titleNotMine": "发布 Rider — 只有所有者才能发布此 Rider",
    "topbar.publish.titlePublished": "已发布为 v{version} — 公开链接: {url}（点击取消发布）",
    "topbar.publish.unpublishLabel": "取消发布",
    "topbar.publish.titleDefault": "发布 Rider — 生成只读公开访问链接（便于在打印件上生成二维码）",

    // --- editor page chrome (pages/editor-page.ts, EDITOR_PAGE_HTML template) ----------------------------
    "editor.riderIdTitle": "已保存的 Rider ID（空白 = 未保存的新 Rider）",
    "editor.menuToggleTitle": "折叠/展开菜单",
    "editor.menuToggleLabel": "菜单",
    "editor.overflowMenuTitle": "更多",
    "editor.rightPanelCollapseTitle": "收起面板",
    "editor.rightPanelExpandTitle": "展开面板",
    "editor.rightPanelResizerTitle": "拖动以调整面板宽度(双击可恢复自动宽度)",
    "editor.undoTitle": "撤销 ({mod}+Z)",
    "editor.undoLabel": "撤销",
    "editor.redoTitle": "重做 ({mod}+Shift+Z)",
    "editor.redoLabel": "重做",
    "editor.rotateTitle":
        "旋转 (R) — 切换旋转环；拖拽以旋转。默认整体旋转（对象+子级）；按住 Alt 仅旋转当前对象。",
    "editor.rotateLabel": "旋转",
    "editor.attachArmedHint": "点击要把“{title}”附着到的物体：台面、支架 · 按 Esc 取消",
    "editor.modifierAltHint": "Alt — 仅此对象",
    "editor.modifierAltStackHint": "Alt — 整叠",
    "editor.modifierShiftHint": "Shift — 点击物体以加入编组，松开完成（拖拽时松开可附着）",
    "editor.uploadObjectTitleDisabled": "上传 3D 模型 — 限管理员",
    "editor.uploadObjectTitleAdmin": "上传 3D 模型 — 从 .glb 文件创建全局预设",
    "editor.uploadObjectLabel": "上传 3D 模型",
    "editor.deleteObjectLabel": "删除选中的对象",
    "editor.deleteObjectTitle": "删除选中的对象 (Alt+Delete)",
    "editor.savePresetLabel": "保存预设",
    "editor.deleteSubtreeLabel": "删除对象及其所有子级",
    "editor.deleteSubtreeTitle": "删除对象及其所有子级 (Delete)",
    "editor.selectMode.groupLabel": "整叠",
    "editor.selectMode.groupTitle": "选择范围：整叠 — 拖动、旋转和删除作用于整组（按住 Alt 只选单件）",
    "editor.selectMode.itemLabel": "单件",
    "editor.selectMode.itemTitle": "选择范围：单件 — 拖动、旋转和删除作用于点中的物体（按住 Alt 选整叠）",
    "editor.deleteInGroupLabel": "删除整叠",
    "editor.deleteInGroupTitle": "删除整叠 (Delete) — Alt：仅删除点中的物体",
    "editor.deleteInItemLabel": "删除该物体",
    "editor.deleteInItemTitle": "删除点中的物体 (Delete) — Alt：删除整叠",
    "editor.deleteGroupConfirm.heading": "删除整叠？",
    "editor.deleteGroupConfirm.body": "“{title}” 将连同其上的全部物体一起从舞台移除。物体数量：{n}。",
    "editor.deleteGroupConfirm.confirmLabel": "删除整叠",
    "editor.showAnnotationsLabel": "显示/隐藏标注",
    "editor.annotationOptionsTitle": "标注内容显示选项",
    "editor.annotationContentAriaLabel": "标注内容",
    "editor.labelsPlaqueStrip": "LABELS",
    "editor.annotationCh": "CH",
    "editor.topViewTitle": "俯视图",
    "editor.topViewLabel": "俯视图",
    "editor.planViewTitle": "平面图",
    "editor.planViewLabel": "平面图",
    "editor.view3dLabel": "3D",
    "editor.view3dTitle": "3D 视图",
    "editor.topViewShort": "Top",
    "editor.planViewShort": "Plan",
    "editor.viewSwitcherAriaLabel": "视图",
    "editor.viewSwitcherOptionsTitle": "视图选项",
    "editor.planViewLoading": "正在绘制平面图…",
    "editor.planViewFailed": "无法加载符号库。",
    "editor.status.planMoveRefused": "该物体无法移动到那里。",
    "presetMenu.editMode": "编辑",
    "presetMenu.editModeDone": "完成",
    "presetMenu.reorderFailed": "无法保存新顺序：{error}",
    "presetMenu.setDefaultOrder": "设为默认顺序",
    "presetMenu.defaultOrderSaved": "此顺序现已成为所有未自行排序用户的默认顺序。",
    "editor.annotationSource": "音源",
    "editor.annotationMix": "MIX",
    "editor.annotationTitle": "标题",
    "editor.annotationDesc": "描述",
    "editor.showGridLabel": "显示/隐藏坐标网格",
    "editor.printLabel": "打印 Rider",
    "editor.printTitle": "导出 PDF 并打印",
    "editor.exitLabel": "返回“我的 Rider”",
    "editor.riderOperationsAriaLabel": "Rider 操作",
    "editor.tabs.properties": "Properties",
    "editor.tabs.propertiesTitle": "Properties (E)",
    "editor.tabs.rider": "Rider",
    "editor.tabs.inputList": "Input List",
    "editor.tabs.inputListTitle": "Input List (I)",
    "editor.tabs.outputList": "Output List",
    "editor.tabs.outputListTitle": "Output List (O)",
    "editor.tabs.gearList": "Gear List",
    "editor.riderTab.heading": "Rider 参数",
    "editor.riderTab.titleLabel": "名称",
    "editor.riderTab.commentLabel": "备注",
    "editor.riderTab.stageWidthLabel": "宽度 (m)",
    "editor.riderTab.stageDepthLabel": "深度 (m)",
    "editor.riderTab.useBorderLabel": "限制舞台边缘",
    "editor.riderTab.useBorderHint": "(关闭 = 允许物体放置在舞台之外，如调音台、装饰等)",
    "editor.riderTab.contactLegend": "联系人与乐队",
    "editor.riderTab.moduleRider": "技术需求",
    "editor.riderTab.moduleStage": "舞台",
    "editor.riderTab.moduleBand": "乐队",
    "editor.riderTab.moduleContact": "联系人",
    "editor.riderTab.contactHint": "(预填自个人资料；随当前 Rider 一起保存)",
    "editor.riderTab.bandNameLabel": "乐队名称",
    "editor.riderTab.bandLogoAlt": "乐队 Logo",
    "editor.riderTab.bandLogoFileLabel": "Logo 文件",
    "editor.riderTab.removeLogo": "移除 Logo",
    "editor.riderTab.contactNameLabel": "联系人姓名",
    "editor.riderTab.contactPhoneLabel": "联系电话",
    "editor.riderTab.contactEmailLabel": "联系邮箱",
    "editor.riderTab.saveDefaultsTitle":
        "将上述联系人/乐队信息保存为默认设置 — 将预填至您创建的每个新 Rider 中",
    "editor.riderTab.saveDefaultsLabel": "保存为我的默认值",
    "editor.riderTab.riderTextLabel": "Rider 文本说明",
    "editor.riderTab.savedDefaultsStatus": "已保存为默认设置。",
    "editor.riderTab.savedDefaultsFailed": "无法保存默认设置: {message}",
    "editor.listHint": "(整个 Rider — 拖拽行调整顺序；Ch = 列表中的位置。点击行以选中对应 3D 对象。)",
    "editor.reorderAriaLabel": "调整顺序",
    "editor.table.ch": "通道",
    "editor.table.source": "音源",
    "editor.table.type": "类型",
    "editor.table.chName": "通道标识",
    "editor.table.micDi": "话筒 / DI",
    "editor.table.out": "OUT",
    "editor.table.comment": "备注",
    "editor.table.name": "名称",
    "editor.table.category": "分类",
    "editor.table.owner": "归属",
    "editor.table.weight": "重量",
    "editor.table.count": "数量",
    "editor.inputTab.heading": "Input List (输入通道表)",
    "editor.inputTab.addButton": "添加输入通道",
    "editor.outputTab.heading": "Output List (输出线路表)",
    "editor.outputTab.addButton": "添加输出线路",
    "editor.gearTab.heading": "Gear List (设备清单)",
    "editor.gearTab.hint": "(整个 Rider — 每个对象的所属设备。点击行以选中对应 3D 对象。)",
    "editor.gearTab.addButton": "添加设备项目",
    "editor.params.closeTitle": "取消选择 / 关闭",
    "editor.params.emptyHint": "Select an object on the stage to see its properties.",
    "editor.params.heading": "当前选中对象",
    "editor.params.nameLabel": "模型标识",
    "editor.params.nameHint": "(目录键名，只读)",
    "editor.params.titleLabel": "名称标题",
    "editor.params.titleToSourceLabel": "将标题填入音源",
    "editor.params.commentLabel": "备注",
    "editor.params.parentLabel": "父级对象",
    "editor.params.xLabel": "X",
    "editor.params.yLabel": "Y",
    "editor.params.zLabel": "Z",
    "editor.params.zTitle": "相对舞台的高度（米）。用于放在舞台平面之外的装饰物，例如屏幕或幕布。",
    "editor.params.turnLabel": "旋转角度°",
    "editor.params.lockPositionLabel": "锁定位置",
    "editor.params.lockChildrenLabel": "锁定子级",
    "editor.params.structureLabel": "舞台结构件",
    "editor.params.structureHint": "(其他物体可叠加摆放在其上方)",
    "editor.params.heightLabel": "高度, m",
    "editor.params.heightHint": "(表面高度)",
    "editor.params.riserAcrossLabel": "宽度, m",
    "editor.params.riserDeepLabel": "深度, m",
    "editor.params.riserHeightsLabel": "常用高度, m",
    "editor.params.riserResizeLabel": "在舞台上移动并调整大小",
    "presetMenu.riserTooltipHint": "双击调整大小",
    "editor.params.riserResizeDoneLabel": "完成",
    "editor.params.riserResizeHint": "拖动物体可移动，拖动控点可调整大小。Shift = 自由，Enter 或 Esc = 完成。",
    "editor.params.stageMoveLabel": "在舞台上移动",
    "editor.params.stageMoveHint": "在舞台上拖动即可移动。Shift = 自由，Enter 或 Esc = 完成。",
    "editor.params.anchoredHint": "已固定——双击可移动或调整大小",
    "editor.params.anchoredMoveHint": "已固定——双击可移动",
    "editor.params.anchoredLockedHint": "已锁定——取消“锁定位置”后才能移动",
    "editor.params.snapToGridLabel": "吸附到网格",
    "editor.params.snapNeedsGridHint": "仅当网格可见时才会吸附（顶栏的网格按钮）。网格隐藏时，所有物体可自由移动。",
    "editor.params.snapToGridHint": "边缘会吸附到物体组成部件所定的网格：升降台为 0.5 米台板，LED 屏为箱体，桁架为标准节。关闭后，物体停在您放置的确切位置。",
    "riser.handle.deep": "拖动以改变深度",
    "riser.handle.across": "拖动以改变宽度",
    "riser.handle.corner": "拖动以同时改变宽度和深度",
    "riser.handle.height": "拖动以改变高度（每步 0.2 m）",
    "riser.handle.dock": "在此侧添加相同的舞台平台",
    "riser.readout": "{across} × {deep} m · 高 {height} m",
    "stage.handle.deep": "拖动以改变舞台深度",
    "stage.handle.across": "拖动以改变舞台宽度",
    "stage.handle.corner": "拖动以同时改变舞台宽度和深度",
    "stage.readout": "舞台 {across} × {deep} m",
    "riser.status.docked": "已在旁边添加一个相同的舞台平台。",
    "ledWall.handle.cols": "拖动以增加或减少箱体列数",
    "ledWall.handle.rows": "拖动以增加或减少箱体行数",
    "construction.led.cabinetLabel": "箱体, mm",
    "construction.led.cabinetCustom": "{w} × {h}（自定义）",
    "construction.led.colsLabel": "列数",
    "construction.led.rowsLabel": "行数",
    "construction.led.pitchLabel": "像素间距, mm",
    "construction.led.mountLabel": "安装方式",
    "construction.led.mountGround": "地面堆叠",
    "construction.led.mountFlown": "吊挂",
    "construction.led.bottomLabel": "底边高度, m",
    "construction.led.contentLabel": "显示内容",
    "construction.led.contentOff": "关闭（黑屏）",
    "construction.led.contentGrid": "箱体网格",
    "construction.led.contentBars": "彩条",
    "construction.led.contentLogo": "标志画面",
    "construction.led.contentImage": "图片",
    "construction.led.contentMedia": "媒体",
    "construction.led.chooseImage": "选择图片…",
    "construction.led.removeImage": "移除图片",
    "construction.led.imageSet": "已将图片设置到 LED 屏（{w} × {h} 像素）。",
    "construction.led.imageTooBig": "图片缩小后仍然过大，请选择更小的图片。",
    "construction.led.imageUnreadable": "无法将此文件读取为图片。",
    "construction.led.imageRemoved": "已从 LED 屏移除图片。",
    "construction.led.mediaLabel": "媒体",
    "construction.led.mediaLogo": "SoundCheckBox 标志",
    "construction.led.mediaMascot": "吉祥物",
    "construction.led.mediaIntro": "片头",
    "construction.led.mediaIntroPlain": "片头（不带钱）",
    "construction.led.mediaTutorial": "教程视频",
    "construction.led.mediaCustomUpload": "已上传：{name}",
    "construction.led.mediaCustomLink": "链接：{host}",
    "construction.led.mediaUrlLabel": "直接链接（https）",
    "construction.led.mediaUrlPlaceholder": "https://…/video.mp4",
    "construction.led.mediaUrlUse": "显示此链接",
    "construction.led.mediaUpload": "上传视频或图片…",
    "construction.led.mediaChecking": "正在检查链接…",
    "construction.led.mediaUploading": "正在上传…",
    "construction.led.mediaSet": "屏幕现在显示所选内容。",
    "construction.led.mediaProblemEmpty": "请粘贴指向视频或图片文件的链接。",
    "construction.led.mediaProblemStreaming": "无法在屏幕上显示 {site} 页面：{site} 只在自己的播放器里播放视频。请使用指向文件（.mp4 或 .webm）的直接链接，或上传文件。",
    "construction.led.mediaProblemNotHttps": "链接必须以 https:// 开头。",
    "construction.led.mediaProblemCredentials": "请从链接中去掉用户名和密码。",
    "construction.led.mediaProblemNotAddress": "这不是网址。请粘贴以 https:// 开头的完整链接。",
    "construction.led.mediaProblemTooLong": "链接太长。",
    "construction.led.mediaFailCors": "该网站不允许在其他页面上显示它的视频。",
    "construction.led.mediaFailUnreachable": "该地址没有响应。请检查链接和网络连接。",
    "construction.led.mediaFailHttp": "该地址返回了错误（{status}）：文件不存在或不公开。",
    "construction.led.mediaFailNotMedia": "该地址是网页或流列表，不是视频或图片文件。请使用指向 .mp4、.webm、.png、.jpg 或 .gif 文件的直接链接。",
    "construction.led.mediaFailFormat": "浏览器无法播放此文件。请使用 mp4（H.264）或 webm 视频，或 png、jpeg、gif 图片。",
    "construction.led.mediaUploadForbidden": "只有管理员可以上传媒体。",
    "construction.led.mediaUploadType": "屏幕上只能放 mp4、webm、png、jpeg 和 gif 文件。",
    "construction.led.mediaUploadEmpty": "文件是空的。",
    "construction.led.mediaUploadTooBig": "文件太大：视频最大 {video} MB，图片最大 {image} MB。",
    "construction.led.mediaUploadFailed": "上传失败，请重试。",
    "construction.led.derivedSize": "{size} m",
    "construction.led.derivedPx": "{px} 像素",
    "construction.led.derivedCount": "箱体数：{count}",
    "construction.led.derivedLoad": "约 {kg} kg · 最大约 {kw} kW",
    "construction.truss.typeLabel": "类型",
    "construction.truss.typeLadder": "平面桁架",
    "construction.truss.typeTriangle": "三角桁架",
    "construction.truss.typeBox": "方形桁架",
    "construction.truss.profileLabel": "截面, mm",
    "construction.truss.lengthLabel": "长度, m",
    "construction.truss.trimLabel": "底部高度, m",
    "construction.truss.supportLabel": "支撑方式",
    "construction.truss.supportFlown": "吊挂（电动葫芦）",
    "construction.truss.supportFloor": "地面放置",
    "construction.truss.supportGoalpost": "龙门架（两根立柱）",
    "construction.truss.sections": "分段：{sections}",
    "construction.truss.towers": "立柱 2 × {h} m",
    "construction.truss.longSpan": "跨度较长 — 请查阅载荷表",
    "editor.params.listsInputs": "输入",
    "editor.params.listsOutputs": "输出",
    "editor.params.listsGear": "设备",
    "editor.params.moduleObject": "对象",
    "editor.params.modulePosition": "位置",
    "editor.params.listPosition": "项",
    "editor.params.listPositions": "项",
    "editor.params.actionsLegend": "对象操作",
    "editor.params.rotateHint":
        "可使用顶部栏的 <strong>旋转</strong> 工具或直接在上方 <strong>旋转角度</strong> 输入框中填入精确数值。",
    "editor.params.addChildLabel": "添加子级",
    "editor.params.deleteObjectLabel": "删除对象",
    "editor.params.savePresetTitle": "将此对象及其子级保存为可复用的预设",
    "editor.params.savePresetLabel": "保存为预设",
    "editor.params.addInputLabel": "添加输入通道",
    "editor.params.addOutputLabel": "添加输出线路",
    "editor.params.linkOutputLabel": "关联到输出",
    "editor.params.linkOutputTitle": "将此对象关联到已有的输出线路或通道号",
    "editor.params.linkOutputDisabledTitle": "舞台上没有其他可供链接的输出线路",
    "editor.params.addGearLabel": "添加设备",
    "editor.presetCategoriesAriaLabel": "预设分类",
    "editor.exitConfirm.title": "未保存即离开？",
    "editor.exitConfirm.body": "您在此 Rider 中有未保存的更改。如果现在离开，改动将丢失。",
    "editor.exitConfirm.saveAndLeave": "保存并离开",
    "editor.exitConfirm.leaveWithoutSaving": "不保存直接离开",

    // --- editor page behaviour (pages/editor-page.ts, JS-built status messages) ---------------------------
    "editor.status.gluedToGroup": "已加入该组——现在 {members} 个物体一起移动。",
    "editor.status.glueNoTarget": "放置点下方没有物体——按住 Shift 悬停在物体上即可加入它所在的组。",
    "editor.status.glueFailed": "无法加入该组：{reason}",
    "editor.status.detached": "已移出所在的组——现在可以单独移动。",
    "editor.status.detachNotGrouped": "该物体不属于任何组。",
    "editor.status.multiSelectCount": "已选中 {count} 个待编组——松开 Shift 完成。",
    "editor.status.grouped": "已编组 {count} 个物体。",
    "editor.status.groupFailed": "编组失败：{reason}",
    "editor.status.attachCancelled": "已取消绑定。",
    "editor.status.attachFailed": "绑定失败: {reason}",
    "editor.status.attached": "已将 {source} 绑定至 {target}。",
    "editor.status.undo": "已撤销。",
    "editor.status.redo": "已重做。",
    "editor.status.attachArmed": "绑定模式已激活 — 请点击作为 {name} 父级的对象（按 Escape 取消）。",
    "editor.status.savingCopy": "正在保存您的副本…",
    "editor.status.savedAsCopy":
        "已保存为新的 Rider — 您的专属副本。原作品属于其他人，保持不变。",
    "editor.status.saved": "已于 {time} 保存。",
    "editor.status.guestDraftRestored": "上次的工作已恢复 — 它保存在此浏览器中，直到你把它存入账户。",
    "editor.status.guestDraftDiscarded": "此浏览器中保存的工作无法安全打开，因此已被丢弃而不是重试。将从一个新的空白 rider 开始。",
    "editor.status.guestDraftNotSaved": "你的浏览器无法在此保存更改（存储空间可能已满）。请保持此标签页打开，或登录并保存以保留你的工作。",
    "editor.draft.offer": "{time} 的未保存更改。",
    "editor.draft.continue": "恢复这些修改",
    "editor.draft.discard": "保留当前打开的内容",
    "editor.draft.close": "关闭——稍后再决定",
    "editor.naming.offer": "已保存。该技术文件仍叫「New rider」，乐队也未命名——以后正是靠这些找到它。",
    "editor.naming.name": "现在命名",
    "editor.naming.later": "稍后",
    "editor.draft.offerDiverged": "你有 {time} 的未保存更改，但此后这份 rider 又在服务器上保存过。把它们恢复上去会覆盖较新的工作。",
    "editor.draft.openAsCopy": "将我的更改作为副本打开",
    "editor.draft.useSaved": "使用已保存的版本",
    "editor.draft.restored": "你的未保存更改已恢复。点击“保存”以保留它们。",
    "editor.draft.restoredAsCopy": "你的更改已作为新的未保存 rider 打开。已保存的原件未被改动。点击“保存”以保留副本。",
    "editor.draft.notKept": "你的浏览器无法保留更改的恢复副本（存储空间可能已满）。请点击“保存”，以免退出登录时丢失。",
    "editor.draft.crashed": "此浏览器中保存的未保存更改无法安全打开，因此已被丢弃而不是重试。",
    "editor.status.modelsUnavailable": "部分 3D 模型未能加载 — 对象以带标签的方块显示。你的工作没有丢失。",
    "editor.status.presetsUnavailable": "对象目录未能加载 — 仍可继续绘制，但预设菜单为空。请重新加载页面重试。",
    "editor.status.guestSaveNeedsAccount": "登录或注册即可保存该 rider — 你的工作不会丢失，会随你一起转移。",
    "editor.status.guestSaveFailed": "无法保存到你的账户：{message}。你的工作仍在这里 — 按“保存”重试。",
    "editor.status.saveFailed": "保存失败: {message}",
    "editor.saveAs.heading": "另存为新的技术需求单",
    "editor.saveAs.nameLabel": "名称",
    "editor.saveAs.confirm": "保存副本",
    "editor.saveAs.hint": "当前打开的技术需求单保持不变——这里会以你指定的名称另存一份独立的副本。",
    "editor.saveAs.untitled": "未命名技术需求单",
    "editor.status.savedAsNamedCopy": "已将“{title}”保存为新的技术需求单。当前打开的技术需求单未变。",
    "editor.status.unpublished": "已取消发布 — 此 Rider 的所有公开链接（当前及早前版本）已失效。",
    "editor.status.published": "已发布为 v{version} — 公开链接: {url}",
    "editor.status.publishedNoPicture": "已发布，但未能生成平面图快照——请留在本标签页再次发布，读者便能在模型加载时看到舞台。",
    "editor.status.copiedSuffix": " (已复制到剪贴板)",
    "editor.status.publishFailed": "发布失败: {message}",
    "publishProgress.publishing": "正在发布 rider…",
    "publishProgress.drawing": "已发布为 v{version}。正在为公开页面绘制舞台平面图…",
    "publishProgress.done": "已发布为 v{version} — 公开页面已就绪，包含舞台平面图。",
    "publishProgress.published": "已发布为 v{version} — 公开页面已就绪。",
    "publishProgress.noPicture": "已发布为 v{version}，但无法绘制舞台平面图。模型加载后读者会看到舞台。请不要离开此标签页并重新发布以添加图片。",
    "publishProgress.failed": "发布失败：{message}",
    "publishProgress.open": "打开公开页面",
    "editor.status.ioKeptNote": " 其关联的通道保留为未连接的占位符。",
    "editor.status.ioOptimizedNote": " 其关联通道已被移除，序号已自动紧凑重排。",
    "editor.status.deletedWithChildren": "已删除 {title}；保留了 {count} 个子级对象并原地重新指定了层级。",
    "editor.status.deleted": "已删除 {title}。",
    "editor.status.deletedSubtree": "已删除 {title} 及其所有子级对象。",
    "editor.status.rotated": "已将 {name} 旋转 {deg}° ({mode})。",
    "editor.status.rotateModeObject": "仅对象本身；子级保持原位",
    "editor.status.rotateModeSet": "整体旋转",
    "editor.status.moved": "已移动 {name} 至 X {x}, Y {y}。",
    "editor.status.dropMissed": "未落入舞台区 — 请尝试拖拽至离台面更近的位置。",
    "editor.status.loadingRider": "正在加载技术需求单…",
    "editor.status.loaded": "已加载“{title}”— 舞台上的对象数: {count}。",
    "editor.status.loadedNotMineSuffix":
        " 此 Rider 属于其他人 — 您可以自由编辑，但点击保存时将另存为您的专属新副本。",
    "editor.status.loadFailed": "加载失败: {message}",
    "editor.status.newRider": "新 Rider (尚未保存)。",

    // --- object-params panel behaviour (components/object-params-panel.ts) -------------------------------
    "objectParams.status.reparentFailed": "无法更改父级: {reason}",
    "objectParams.status.moved": "已移动 {name} 至 {location} 下。",
    "objectParams.status.locationNewParent": "新的父级对象",
    "objectParams.status.locationTopLevel": "顶层",
    "objectParams.status.lockedChildren": "已锁定 {name} 所有后代对象的位置。",
    "objectParams.status.reseated": "已重新放置放置在 {name} 上的 {n} 个对象。",
    "objectParams.status.addedInput": "已为 {name} 添加输入通道。",
    "objectParams.status.addedOutput": "已为 {name} 添加输出线路。",
    "objectParams.status.addedGear": "已为 {name} 添加设备项目。",
    "objectParams.status.addedChild": "已将 {childName} 添加到 {name}。",
    "objectParams.status.removed": "已移除 {name}。剩余对象的通道保持不变。",
    "objectParams.noParentOption": "(无父级 — 处于顶层)",

    // --- preset menu (components/preset-menu.ts) ----------------------------------------------------------
    "presetMenu.loading": "正在加载预设…",
    "presetMenu.loadFailed": "无法加载物品目录。请重新加载页面以重试。",
    "presetMenu.countSuffix": "({count})",
    "presetMenu.searchPlaceholder": "搜索目录",
    "presetMenu.searchNoMatch": "没有与“{q}”匹配的结果",
    "presetMenu.noMatch": "没有符合条件的预设。",
    "presetMenu.onlyMine": "仅我的",
    "presetMenu.added": '已将预设 "{name}" 添加到舞台。',
    "presetMenu.removeFromCategory": "从「{category}」中移除",
    "presetMenu.removedFromCategory": "已将「{name}」从「{category}」移除，预设本身未受影响。",
    "presetMenu.removeFromCategoryFailed": "无法将「{name}」从「{category}」移除：{message}",
    "presetMenu.deleteLastCategoryPrompt": "这是它唯一的分类。删除将永久移除该预设，且无法恢复。确定删除？",
    "presetMenu.deleteAlsoFromPrompt": "将永久删除该预设——它也会从「{others}」中消失，且无法恢复。确定删除？",
    "presetMenu.deleting": '正在删除预设 "{name}"…',
    "presetMenu.deleted": '已删除预设 "{name}"。',
    "presetMenu.deleteFailed": '删除预设 "{name}" 失败: {message}',
    "presetMenu.uncategorizedCategory": "未分类",
    "presetMenu.chooseCategoryPlaceholder": "— 分配分类 —",
    "presetMenu.assignedCategory": '已将预设 "{name}" 分配至分类「{category}」。',
    "presetMenu.assignCategoryFailed": '无法将分类分配给预设 "{name}": {message}',

    // --- Patch Editor (components/patch-editor-dialog.ts) — SCRUM-241 ---------------------------------------
    "patchEditor.title": "跳线与舞台接口箱管理 (Patch Editor)",
    "patchEditor.subtitle": "自动计算 {count} 个音频通道在各舞台接口箱的物理路由与线缆",
    "patchEditor.stageBoxesHeading": "数字接口箱与机架 (StageBoxes)",
    "patchEditor.routingTableHeading": "通道分配与跳线表",
    "patchEditor.colChannel": "Rider 通道",
    "patchEditor.colSource": "声源/线路",
    "patchEditor.colSubSnake": "分舞台箱 / Drop Box",
    "patchEditor.colSocket": "插口",
    "patchEditor.colStageBox": "目标接口箱",
    "patchEditor.colBoxInput": "机架输入口",
    "patchEditor.colCableLength": "话筒线长",
    "patchEditor.cableSummaryHeading": "线缆包装清单 (装箱规范)",
    "patchEditor.printSheet": "打印跳线表",
    "patchEditor.close": "关闭",
    "patchEditor.done": "完成",
    "topbar.patchEditor": "跳线",
    "topbar.patchEditor.disabledTooltip": "跳线管理 — 仅在「演出 / 巡演 (Show/Tour)」模式下、当 Rider 关联至具备接口箱和调音台的演出场地时可用。",
    "topbar.patchEditor.activeTooltip": "打开跳线与舞台接口箱管理 (P)",

    // --- I/O keep-on-delete dialog (components/io-delete-dialog.ts) ----------------------------------------
    "ioDelete.heading": "保留通道序号还是紧凑重排列表？",
    "channelOverflow.heading": "空闲通道不足",
    "channelOverflow.summary": "「{preset}」需要 {need} 个输入通道，空闲 {free} 个（{slots}），还差 {short} 个。",
    "channelOverflow.movingLine": "CH {ch} — {source} / {name}",
    "channelOverflow.movingMore": "{lines} … 以及另外 {n} 条",
    "channelOverflow.nothingToMove": "空闲通道之上没有内容——顺延不会移动任何通道。",
    "channelOverflow.appendLabel": "追加到末尾（CH {channels}）",
    "channelOverflow.shiftLabel": "从 CH {from} 起顺延 {n}",
    "channelOverflow.cancelled": "「{name}」未添加——你取消了通道选择。",
    "ioDelete.optimizeLabel": "优化并紧凑通道",
    "ioDelete.keepLabel": "保持当前编号",
    "ioDelete.rememberLabel": "记住我的选择 (不再询问)",
    "ioDelete.inputChannelSingular": "{n} 个输入通道",
    "ioDelete.inputChannelPlural": "{n} 个输入通道",
    "ioDelete.outputChannelSingular": "{n} 个输出线路",
    "ioDelete.outputChannelPlural": "{n} 个输出线路",
    "ioDelete.summary": "您要删除的对象包含 {parts}。",

    // --- row-edit dialog (components/row-edit-dialog.ts) — docs/V2_IO_KEEP_ON_DELETE.md §3c --------------
    "rowEdit.headingInput": "编辑输入通道",
    "rowEdit.headingOutput": "编辑输出行",
    "rowEdit.sourceLabel": "音源",
    "rowEdit.chNameLabel": "通道名称",
    "rowEdit.typeLabel": "类型",
    "rowEdit.commentLabel": "备注",
    "rowEdit.lockedLabel": "已锁定",
    "rowEdit.chHashLabel": "通道 #",
    "rowEdit.lockedHint": "已锁定行的通道无法更改。取消勾选“已锁定”以移动它，然后保存——解锁和移动会在同一次保存中一起完成。",
    "rowEdit.lockedHintInput": "已锁定通道的编号无法更改。取消勾选“已锁定”以移动它，然后保存——解锁和移动会在同一次保存中一起完成。",
    "rowEdit.linkedLabel": "同时连接（共享混音）",
    "rowEdit.linkedHint": "由同一个混音供给的其他返听音箱——例如共用一路的两个地板返听。它们也会在舞台图上显示这条线路的通道号。",
    "rowEdit.linkedEmpty": "舞台上暂时没有其他返听音箱。",
    "rowEdit.saveLabel": "保存",
    "rowEdit.deleteChannel": "删除通道",
    "rowEdit.deleteLine": "删除行",
    "rowEdit.errorInvalidChannel": "通道必须是大于或等于 1 的数字。",
    "rowEdit.errorChannelTaken": "通道 {channel} 已被另一行占用——请选择空闲编号。",
    "rowEdit.errorLineGone": "此行已不存在——请关闭此对话框并重试。",
    "rowEdit.errorChannelGone": "此通道已不存在——请关闭此对话框并重试。",

    // --- link to existing output dialog (components/link-output-dialog.ts) ------------------
    "linkOutput.heading": "关联到已有输出",
    "linkOutput.currentlyLinkedLabel": "当前已关联的输出：",
    "linkOutput.selectOutputLabel": "选择输出线路：",
    "linkOutput.chooseOutputOption": "选择已有输出...",
    "linkOutput.manualOption": "手动输入通道号...",
    "linkOutput.manualChannelLabel": "通道号：",
    "linkOutput.submitLabel": "关联",
    "linkOutput.unlinkButtonTitle": "取消关联此输出",
    "linkOutput.ownerSuffix": "拥有此输出",
    "linkOutput.alreadyLinkedSuffix": "已关联",
    "linkOutput.errorSelectChannel": "请选择一个输出或输入有效的通道号。",
    "linkOutput.error.invalidChannel": "请输入 1 或更大的通道号。",
    "linkOutput.error.nodeNotFound": "该物件已不在舞台上。请关闭此窗口并重新选择。",
    "linkOutput.error.alreadyOwner": "该输出已属于此物件，无需再关联。",
    "linkOutput.error.channelNotFound": "该通道上还没有输出。请先用「Add new Output」创建。",
    "linkOutput.errorGeneric": "无法关联到输出。",
    "linkOutput.status.linked": "已将 {name} 关联到输出 {channel}",
    "linkOutput.status.unlinked": "已取消 {name} 与输出 {channel} 的关联",

    // --- save-preset dialog (components/save-preset-dialog.ts) ---------------------------------------------
    "savePreset.heading": "保存为预设",
    "savePreset.nameLabel": "预设名称",
    "savePreset.categoryLabel": "分类",
    "savePreset.categoryRequiredHint": "(必填)",
    "savePreset.saveAsLabel": "保存方式",
    "savePreset.iconLegend": "图标",
    "savePreset.renderingHint": "正在渲染对象快照…",
    "savePreset.useRenderedIcon": "使用 3D 快照",
    "savePreset.useOriginalIcon": "使用原始预设图标",
    "savePreset.clearUploaded": "清除上传的文件",
    "savePreset.submitLabel": "保存预设",
    "savePreset.usingUploadedImage": "使用您上传的图片。",
    "savePreset.usingOriginalPresetIcon": "使用原始预设图标 — 也可切换为 3D 快照或上传文件。",
    "savePreset.autoGenerated": "根据 3D 模型自动生成 — 上传文件可覆盖它。",
    "savePreset.iconPreviewAlt": "预设图标预览",
    "savePreset.chooseCategoryOption": "— 选择分类 —",
    "savePreset.newPresetOption": "新建预设",
    "savePreset.overwriteOption": "覆盖现有的: {title}",
    "savePreset.sharedLibrarySuffix": "（共享库）",
    "savePreset.confirmOverwriteButton": "是，覆盖",
    "savePreset.backToEdit": "返回",
    "savePreset.overwriteWarning": '覆盖将替换 "{title}" — 此后每次插入都会使用您的新版本。已经使用过它的技术需求单会保留添加时的副本，不会改变。',
    "savePreset.overwriteWarningSharedNote": "该预设属于共享库 — 您的更新对所有人可见。",
    "savePreset.subject": "{title} — 包含 {count} 个对象，将连同整个子级树一起保存。",
    "savePreset.renderFailed": "无法生成图标渲染 — 预设将无图标保存。",
    "savePreset.errorNodeGone": "选中的对象已不存在 — 请关闭此窗口并重新选择对象。",
    "savePreset.errorNoCategory": "请选择分类 — 未分类的预设将无法在菜单中显示。",
    "savePreset.errorStaleTarget": "您已无法覆盖该预设 — 请重新打开窗口并重试。",
    "savePreset.updated": '已更新预设 "{title}" (id {id}) — 更改已实时生效。',
    "savePreset.saved": '已保存预设 "{title}" (id {id}) — 已添加到预设菜单。',
    "savePreset.saveFailed": "无法保存预设: {message}",
    "savePreset.imageReadFailed": "无法读取该图片: {message}",

    // --- AI 助手 (components/ai-assistant-dialog.ts) ---
    "ai.buttonTitle": "AI 助手 — 用文字描述修改",
    "ai.buttonLabel": "AI",
    "ai.heading": "AI 助手",
    "ai.subheading": "用日常语言描述对舞台的修改。每项改动在应用前都会先由你确认。",
    "ai.promptLabel": "你的请求",
    "ai.promptPlaceholder": "例如：在舞台后区中央添加一套架子鼓，并在其左侧放一个贝斯音箱",
    "ai.generate": "生成",
    "ai.record": "语音",
    "ai.recordTitle": "用语音说出你的请求（最长 20 秒）",
    "ai.recording": "录音中……点击麦克风停止。",
    "ai.stopRecording": "停止录音",
    "ai.micUnsupported": "此浏览器不支持语音输入。",
    "ai.micDenied": "麦克风访问被拒绝——请在浏览器中允许以使用语音。",
    "ai.micEmpty": "没有录到音频，请重试。",
    "ai.generating": "思考中…",
    "ai.previewHeading": "建议的改动",
    "ai.apply": "应用改动",
    "ai.discard": "放弃",
    "ai.emptyPrompt": "请先输入你想修改的内容。",
    "ai.noChanges": "助手没有提出任何改动。请尝试换一种说法。",
    "ai.notConfigured": "此服务器尚未启用 AI 助手。",
    "ai.capReached": "你的免费 AI 额度已用完。请在个人资料中添加自己的 Gemini 密钥以继续使用助手。",
    "ai.providerError": "AI 服务暂时不可用，请稍后再试。",
    "ai.invalid": "助手无法为该 rider 生成有效的改动。请尝试换一种说法。",
    "ai.invalidReference": "助手引用了不在此舞台上的对象或预设。请换一种称呼，或先添加它。",
    "ai.someSkipped": "有 {count} 项改动无法应用（引用了舞台上不存在的内容，或放不下），已跳过：",
    "ai.op.add": "添加对象",
    "ai.op.move": "移动对象",
    "ai.op.rotate": "旋转对象",
    "ai.op.delete": "删除对象",
    "ai.op.settings": "更新舞台设置",
    "ai.op.unknown": "一项操作",
    "ai.failed": "无法连接 AI 助手。请检查网络连接后重试。",
    "ai.applied": "已应用助手的 {count} 项改动。",
    "ai.diff.addPreset": "在 ({x}, {y}) 米处添加 {preset}",
    "ai.diff.moveObject": "将 {object} 移动到 ({x}, {y}) 米",
    "ai.diff.rotateObject": "将 {object} 旋转 {deg}°",
    "ai.diff.deleteObject": "删除 {object}",
    "ai.diff.deleteTree": "删除 {object} 及其 {count} 个子对象",
    "ai.diff.setRiderMeta": "更新 rider 设置：{fields}",
    "ai.diff.metaField.title": "标题",
    "ai.diff.metaField.comment": "备注",
    "ai.diff.metaField.width": "舞台宽度",
    "ai.diff.metaField.length": "舞台深度",

    // --- upload-object dialog (components/upload-object-dialog.ts) -----------------------------------------
    "uploadObject.heading": "上传 3D 模型对象",
    "uploadObject.hint": "仅限管理员。从二进制 glTF (.glb) 文件创建全局预设。",
    "uploadObject.nameLabel": "名称",
    "uploadObject.modelLabel": "模型文件 (.glb)",
    "uploadObject.categoryLabel": "分类",
    "uploadObject.iconLabel": "图标 (可选)",
    "uploadObject.heightLabel": "高度, m",
    "uploadObject.structureLabel": "属于结构件 (地台/台架，可放置其他物体)",
    "uploadObject.submitLabel": "上传并创建预设",
    "uploadObject.errorNameRequired": "名称为必填项。",
    "uploadObject.errorModelRequired": "请选择一个 .glb 模型文件。",
    "uploadObject.errorNotGlb": "模型文件必须为 .glb 格式。",
    "uploadObject.errorNoCategory": "请选择一个分类。",
    "uploadObject.uploading": "正在上传…",
    "uploadObject.uploaded": '已上传 "{name}" — 现已加入预设库。',

    // --- list tables (components/list-tables.ts, editor/dom-utils.ts) --------------------------------------
    "dom.deleteLineTitle": "删除此行",
    "dom.editLineTitle": "编辑此行",
    "dom.editChannelTitle": "编辑此通道",
    "dom.deleteChannelTitle": "删除此通道",
    "listTables.unconnectedRowTitle":
        "未连接 — 关联对象已被删除，通道序号被保留。删除此行以释放序号。",
    "listTables.unconnectedChannelTitle": "未连接 — 关联对象已被删除，通道序号被保留。删除它以释放序号。",
    "listTables.phantomTitle": "幻象供电 (+48V) — 点击切换",
    "listTables.dragHandleTitle":
        "拖拽调整顺序 — 列表位置决定通道号。Ctrl/Cmd 或 Shift 点击可多选拖拽。",
    "listTables.clearSelectionTitle": "点击以清除选择",
    "listTables.columnGripTitle": "{name} — 拖动边缘调整宽度，双击边缘自动适配",
    "listTables.panelGripTitle": "拖动可调整面板宽度，与面板自身边缘相同",
    "listTables.noneOption": "(无)",
    "listTables.categoryFromCatalogue": "这是什么由目录决定。要更改，请更换型号，而不是标签。",
    "listTables.categoryStale": "此行指向目录分类 {ref}，该分类已不存在。请重新选择型号。",
    "listTables.gearUngrouped": "不属于任何组合",
    "listTables.selectionBadge": "已选中 {count} 项 — 拖拽任意一项移动分组",
    "listTables.linkLabel": "链接",
    "listTables.unlinkLabel": "取消链接",
    "listTables.pickModeLabel": "多选",
    "listTables.linkTitle": "将所选两行链接为立体声对",
    "listTables.unlinkTitle": "取消所选对的链接（名称保持不变）",
    "listTables.linkNeedTwo": "选择两个相邻的行，将它们链接为立体声对",
    "listTables.linkNotAdjacent": "只能链接相邻的行（通道 N 和 N+1）",
    "listTables.linkAlreadyPaired": "其中一行已在某个对中，请先取消链接",
    "listTables.unlinkNothing": "选择已链接的对以取消链接",
    "listTables.pairMarkTitle": "已链接的立体声对 — 通道 {a} 和 {b}",
    "ioDelete.pairSummary": "这一行是立体声对的一半。另一半将保留并变为单声道行。",
    "listTables.powerApprox": '约 {watts} W/台 — 设备库近似匹配 ("{name}")，实际功率可能存在偏差。',
    "listTables.powerExact": "{watts} W/台，来自设备库匹配: {name}。",
    "listTables.powerLoading": "正在加载功率数据…",
    "listTables.powerError": "设备库不可用 — 未能计算功率总和。",
    "listTables.notFoundInCatalog": "设备库中未找到: {names}",

    // --- power summary (editor/power.ts — shared by the Gear tab AND the printed rider) --------------------
    "power.noGearItems": "暂无设备项目。",
    "power.totalLine": "舞台 / FOH: {backline} W · 主扩声 (PA): {pa} W",
    "power.fromLine": "— 根据 {items} 项中的 {resolved} 项计算。",
    "picker.catalogLoading": "正在加载目录…",
    "picker.samePurpose": "同一用途",
    "picker.family": "相近用途",
    "picker.startTyping": "输入型号或制造商",
    "picker.keepTyped": "按输入保留「{text}」",
    "picker.classAnswers": "符合「{name}」的型号",
    "gear.notInCatalog": "目录中没有",
    "power.itemSingular": "{n} 项设备",
    "power.itemPlural": "{n} 项设备",
    "power.zeroPowerSingular": "{items} 无需交流供电。",
    "power.zeroPowerPlural": "{items} 无需交流供电。",
    "power.unresolvedLine": "{items} 未在设备库中匹配到（未计入）。",

    // --- print document (editor/print-rider.ts) -------------------------------------------------------------
    "printRider.noInputChannels": "无输入通道。",
    "printRider.noOutputChannels": "无输出线路。",
    "printRider.noGearItems": "无设备清单。",
    "printRider.headers.ch": "通道",
    "printRider.headers.v48": "48V",
    "printRider.headers.source": "音源",
    "printRider.headers.micDi": "话筒 / DI",
    "printRider.headers.type": "类型",
    "printRider.headers.owner": "归属",
    "printRider.headers.comment": "备注",
    "printRider.headers.send": "辅助发送",
    "printRider.headers.category": "分类",
    "printRider.headers.name": "名称",
    "printRider.headers.count": "数量",
    "printRider.headers.belongsTo": "隶属于",
    "printRider.headers.offer": "OFFER",
    "printRider.gear.bandBrings": "乐队自带 — 无需租赁",
    "printRider.gear.allCables": "连接本技术要求单所列设备所需的全部线缆",
    "printRider.gear.bandNote": "这些设备乐队自带，将出现在舞台上，无需出租方提供。",
    "printRider.gear.ungrouped": "不属于任何组合",
    "printRider.gear.noCategory": "未分类",
    "gearList.section.pa": "扩声系统 (P.A.)",
    "gearList.section.amplification": "功率放大",
    "gearList.section.mixing": "调音系统",
    "gearList.section.backline": "乐器后备 (Backline)",
    "gearList.section.monitoring": "监听",
    "gearList.section.instruments": "乐器",
    "gearList.section.mics": "话筒与 DI",
    "gearList.section.stands": "支架",
    "gearList.section.stage": "舞台搭建",
    "gearList.section.power": "配电",
    "gearList.section.wire": "线缆",
    "gearList.section.consumables": "耗材",
    "gearList.standFor.microphone": "麦克风架",
    "gearList.standFor.guitar-bass": "吉他与贝斯架",
    "gearList.standFor.keyboard": "键盘架",
    "gearList.standFor.wind": "管乐器架",
    "gearList.standFor.drums-percussion": "鼓与打击乐支架",
    "gearList.standFor.speaker": "音箱架",
    "gearList.standFor.sheet-music-other": "谱架及其他",
    "gearList.drumKit": "架子鼓",
    "gearList.otherInstruments": "其他乐器",
    "gearList.drumKitMics": "架子鼓话筒",
    "gearList.otherMics": "其他话筒和 DI",
    "publicViewer.gear.eachFor": "这 {n} 件中的每一件——用途",
    "gearList.bandBlock": "乐队自带",
    "gearList.where.standalone": "独立位置",
    "gearList.where.standaloneMany": "{count} 个独立位置",
    "gearList.where.acrossStage": "舞台上 {count} 处",
    "gearList.alsoUnder": "另见 {section}：{count}",
    "gearList.derivedFrom": "来自输入列表，通道 {channels} · {source} — 请在输入列表中修改",
    "gearList.groupCount": "{lines} 行 · {items} 件",
    "gearList.groupCountOne": "1 行 · {items} 件",
    "gearList.unstated.pa": "本技术附加条款未指定。",
    "gearList.unstated.mixing": "本技术附加条款未指定 — 根据输入与输出清单计算。",
    "gearList.unstated.band": "乐队自带 — 见清单末尾。",
    "gearList.mixing.need": "输入清单：{inputs}。输出清单：{outputs}。",
    "gearList.mixing.inputs.one": "{n} 路输入",
    "gearList.mixing.inputs.few": "{n} 路输入",
    "gearList.mixing.inputs.many": "{n} 路输入",
    "gearList.mixing.inputs.other": "{n} 路输入",
    "gearList.mixing.outputs.one": "{n} 路输出",
    "gearList.mixing.outputs.few": "{n} 路输出",
    "gearList.mixing.outputs.many": "{n} 路输出",
    "gearList.mixing.outputs.other": "{n} 路输出",
    "gearList.mixing.modelUnstated": "型号未指定。",
    "gearList.mixing.modelUnstatedBare": "型号未指定",
    "gearList.mixing.requirement": "调音系统，容量至少 {inputs} / {outputs}：{picks}。",
    "gearList.mixing.monitorRequirement": "监听调音台，容量至少 {inputs} / {outputs}：{picks}。",
    "gearList.mixing.pickBrand": "任意 {brand} 调音台",
    "mixing.line.title": "调音系统",
    "mixing.monitorDesk.title": "监听调音台",
    "mixing.monitorConsole.title": "监听调音台",
    "mixing.monitor.fromFoh": "来自 FOH",
    "mixing.monitor.separate": "独立调音台",
    "mixing.need.short": "≥{inputs} 入 / {outputs} 出",
    "mixing.notSpecified": "型号未指定",
    "mixing.line.tooltip": "{title}：{picks} — 点击编辑",
    "mixing.dialog.need": "至少 {inputs} 路输入 / {outputs} 路输出（来自清单）",
    "mixing.dialog.close": "关闭",
    "mixing.dialog.remove": "移除 {name}",
    "mixing.dialog.done": "完成",
    "mixing.dialog.digital": "数字",
    "mixing.dialog.analogue": "模拟",
    "mixing.dialog.brandsHint": "选择品牌。该品牌中能满足演出的任意调音台均可，或打开品牌选择具体型号。",
    "mixing.dialog.back": "‹ 品牌",
    "mixing.dialog.anyBrand": "任意 {brand} 调音台",
    "mixing.dialog.anyBrandMeta": "所有能满足演出的型号：{fit} / {total}",
    "mixing.tier.senior": "高端",
    "mixing.tier.mid": "中端",
    "mixing.tier.entry": "入门",
    "mixing.desk.figures": "{inputs} 入 / {outputs} 出",
    "mixing.desk.unknown": "?",
    "mixing.desk.notStated": "容量未标明",
    "mixing.desk.tooSmall": "对本 Rider 来说太小",
    "mixing.desk.discontinued": "已停产",
    "mixing.pick.brand": "任意 {brand}",
    "gearList.bySection": "按分区",
    "gearList.byKit": "按套组",
    "gearList.groupingLabel": "分组",
    "gearList.collapseAll": "全部折叠",
    "gearList.expandAll": "全部展开",
    "printRider.gear.orderSummary": "需提供：{lines} 行，共 {items} 件，{sections} 个分区。",
    "printRider.gear.orderSummaryBand": "乐队另自带 {lines} 行：列在末尾，无需提供。",
    "printRider.gear.youOffer": "您的报价：",
    "printRider.headers.offerHint": "✓ 按要求，或同等设备",
    "printRider.offer.date": "日期",
    "printRider.offer.city": "城市",
    "printRider.offer.venue": "场馆",
    "printRider.offer.company": "租赁公司",
    "printRider.offer.answeredBy": "答复人",
    "printRider.offer.weAsk": "我们的要求",
    "printRider.offer.youOffer": "贵方提供",
    "printRider.gear.derivedFrom": "来自输入列表，通道 {channels}",
    "printRider.gear.summaryLabel": "汇总",
    "printRider.gear.summaryOr": "或：",
    "printRider.gear.inDetail": "明细",
    "printRider.gear.sum.wedgeMixes": "地面返听混音：{count}",
    "printRider.gear.sum.iemMixes": "入耳返听混音：{count}",
    "printRider.gear.sum.otherOutputs": "其他输出：{count}",
    "printRider.gear.sum.microphones": "话筒：{count}",
    "printRider.gear.sum.microphonesWireless": "话筒：{count}，其中无线：{wireless}",
    "printRider.gear.sum.diBoxes": "DI 盒：{count}",
    "printRider.gear.sum.drumKit": "架子鼓，件数：{pieces}",
    "printRider.gear.sum.more": "另有 {count} 项",
    "printRider.offer.heading": "本技术要求直接在文件中答复",
    "printRider.offer.howTitle": "答复方式。",
    "printRider.offer.howTick": "打勾 — 完全按要求",
    "printRider.offer.howEq": "横线 — 贵方提供的替代型号",
    "printRider.offer.howSummary": "每个设备分区以汇总开头：若整个分区均按要求提供，请在汇总处打勾；仅在不同之处逐行答复。",
    "printRider.offer.howNo": "无法提供的项目：请写“无”并说明原因。说明原因即是答复，沉默不是。",
    "printRider.offer.stageAsk": "舞台 {width} × {length} 米。",
    "printRider.offer.signatures": "签字",
    "printRider.offer.preparedBy": "报价方（租赁公司 / 场地）",
    "printRider.offer.acceptedBy": "乐队方确认",
    "printRider.offer.signDate": "日期",
    "printRider.offer.answerOk": "OK",
    "printRider.offer.answerSub": "替代型号：{model}",
    "printRider.offer.answerBandCarried": "由乐队自带",
    "printRider.offer.answerNa": "无法提供：{reason}",
    "printRider.offer.answerVenue": "场地提供",
    "printRider.offer.answerVenueNote": "场地提供：{note}",
    "printRider.offer.answeredHeading": "{supplier} 的报价 · {status} · 第 v{round} 轮回复",
    "printRider.footer.offerFor": "报价对象：______________________",
    "printRider.footer.page": "第 {page} 页，共 {pages} 页",
    "printRider.publicLinkMissing":
        '公开链接: 尚未发布 — 请使用编辑器顶部工具栏的“发布 Rider”按钮获取附带二维码的只读链接。',
    "printRider.publicLinkLabel": "公开链接（扫码或访问）— 只读，无需登录 — v{version}",
    "printRider.qrUnavailable": "二维码不可用（链接过长）— 请使用上方 URL。",
    "printRider.qrAriaLabel": "指向该 Rider 公开页面的二维码",
    "printRider.untitledRider": "未命名 Rider",
    "printRider.stagePlotUnavailable": "舞台布局图不可用。",
    "printRider.stagePlotPending": "正在生成舞台快照…",
    "printRider.stagePlanPending": "正在生成舞台平面图…",
    "printRider.stagePlotAlt": "舞台布局图",
    "printRider.sections.stagePlan": "舞台平面图 — 俯视",
    "printRider.stagePlanAlt": "舞台平面图，俯视",
    "printRider.stagePlanUnavailable": "舞台平面图不可用。",
    "printRider.contactLabel": "联系人: {name}",
    "printRider.telLabel": "电话: {phone}",
    "printRider.emailLabel": "邮箱: {email}",
    "printRider.bandLogoAlt": "乐队 Logo",
    "printRider.footerPage": "第 {page} 页 / 共 {pages} 页",
    "printRider.docTitle": "{heading} — Rider",
    "printRider.metaBrand": "SoundCheckBox 技术 Rider",
    "printRider.idLabel": "ID: {id}",
    "printRider.unsavedId": "(未保存)",
    "printRider.stageSize": "舞台尺寸: {width} × {length} m",
    "printRider.sections.stagePlot": "舞台布局图 (Stage plot)",
    "printRider.sections.riderNotes": "Rider 备注",
    "printRider.sections.inputList": "输入通道表 (Input list)",
    "printRider.sections.outputList": "输出线路表 (Output list)",
    "printRider.sections.gearList": "设备清单 (Gear list)",
    // --- print settings panel (components/print-options-dialog.ts, SCRUM-96) ---
    "printVariant.heading": "要打印什么？",
  "printVariant.simpleName": "Simple View",
  "printVariant.simpleNote": "一张横向页面：舞台图在上，输入与输出清单在下。",
  "printVariant.techName": "Tech stage plot",
  "printVariant.techNote": "一页黑白舞台图 — 给技术团队",
  "printVariant.bothName": "两页",
  "printVariant.bothNote": "两页：黑白给技术团队，彩色给艺人",
  "printVariant.fullName": "打印全部",
  "printVariant.fullNote": "完整技术需求书，每个部分单独一页。",
  "print.fileNameSimple": "{title} — Simple View",
  "print.fileNameTech": "{title} — Tech Plot",
  "print.fileNameBoth": "{title} — Tech Plot + Simple View",
  "print.fileNameFull": "{title} — Full Details",
  "simpleView.captionSuffix": "在 soundcheckbox.com 查看交互式舞台图并对本技术需求单报价",
  "simpleView.labelTech": "Tech stage plot",
  "simpleView.labelColour": "Simple view",
  "simpleView.captionUnpublished": "未发布的 Rider — {site}",
  "editor.documentTitle": "{title} — SoundCheckBox",
  "editor.documentTitleUntitled": "未命名 Rider",
  "simpleView.plotUnavailable": "舞台图不可用",
  "simpleView.overflow": "部分行未能排入本页。",
  "simpleView.textClipped": "rider 的其余文字见完整打印版 rider 及其公开页面。",
  "printOptions.heading": "打印设置",
    "printOptions.openTitle": "打印设置…",
    "printOptions.hint": "选择页面上要显示的内容。将列标题留空即保留默认名称。",
    "printOptions.presetFull": "完整技术需求书 (rider)",
    "printOptions.presetOnePage": "单页 (横向)",
    "printOptions.gearLegend": "设备清单",
    "printOptions.gearByCategory": "按类别分组",
    "printOptions.gearByKit": "按组合分组",
    "printOptions.pageLegend": "页面",
    "printOptions.pageBreaks": "每个部分单独一页",
    "printOptions.landscapePage": "横向页面",
    "printOptions.alwaysLandscape": "始终横向，整页",
    "printOptions.onCover": "在封面上",
    "printOptions.coverInfo": "信息",
    "printOptions.coverEditContacts": "编辑",
    "printOptions.coverSaveContacts": "保存",
    "printOptions.coverBandLink": "乐队链接",
    "printOptions.coverOff": "不打印",
    "printOptions.coverMissing": "未填写：{fields}",
    "printOptions.coverMissingShort": "未填写：{count}",
    "printOptions.sectionsLegend": "部分",
    "printOptions.lookLegend": "外观",
    "printOptions.coverLegend": "封面",
    "printOptions.cover": "打印封面",
    "printOptions.coverLogoSize": "标识大小",
    "printOptions.coverTextSize": "文字大小",
    "printOptions.coverLogoFile": "标识",
    "printOptions.coverNoLogo": "未上传",
    "printOptions.coverLogoUpload": "上传",
    "printOptions.coverLogoReplace": "替换",
    "printOptions.coverLogoClear": "移除",
    "printOptions.coverLogoFromRider": "标识保存在 rider 中——公开页面和联系人区块用的是同一个",
    "printOptions.coverCheckEmpty": "未填写",
    "printOptions.coverCheck.logo": "标识",
    "printOptions.coverCheck.band": "乐队",
    "printOptions.coverCheck.rider": "Rider",
    "printOptions.coverCheck.contact": "联系人",
    "printOptions.coverCheck.link": "乐队链接",
    "printOptions.coverCheck.qr": "公开链接二维码",
    "printOptions.coverLogo": "标识",
    "printOptions.coverText": "文字",
    "printOptions.align.left": "左对齐",
    "printOptions.align.center": "居中",
    "printOptions.align.right": "右对齐",
    "printOptions.previewTitle": "预览",
    "printOptions.previewBuilding": "正在生成预览…",
    "printOptions.previewFailed": "预览不可用",
    "printOptions.style.plain": "简约",
    "printOptions.style.classical": "古典",
    "printOptions.style.jazz": "爵士",
    "printOptions.style.rock": "摇滚",
    "printOptions.style.metal": "金属",
    "printOptions.style.disco": "迪斯科",
    "printOptions.palette.mono": "黑白",
    "printOptions.palette.graphite": "石墨",
    "printOptions.palette.blue": "蓝色",
    "printOptions.palette.red": "红色",
    "printOptions.palette.amber": "琥珀",
    "printOptions.palette.violet": "紫色",
    "printOptions.inputColumnsLegend": "输入表列 (Input list)",
    "printOptions.outputColumnsLegend": "输出表列 (Output list)",
    "printOptions.confirm": "打印",
    "printOptions.savePdf": "保存为 PDF",
    "printOptions.savedPdf": "PDF 已保存。",
    "printOptions.section.contact": "乐队与联系方式",
    "printOptions.section.publicLink": "公开链接与二维码",
    "printOptions.section.powerSummary": "总功率",
    "printOptions.section.stage3d": "Stage 3D view (in color)",
    "printOptions.section.techTopView": "Stage plot tech top view",

    // --- wysiwyg toolbar (components/wysiwyg-editor.ts) --------------------------------------------------
    "wysiwyg.bold": "加粗",
    "wysiwyg.italic": "斜体",
    "wysiwyg.underline": "下划线",
    "wysiwyg.bulletedList": "无序列表",
    "wysiwyg.numberedList": "有序列表",
    "wysiwyg.clearFormatting": "清除格式",
    "wysiwyg.boldLabel": "B",
    "wysiwyg.italicLabel": "I",
    "wysiwyg.underlineLabel": "U",
    "wysiwyg.bulletedListLabel": "• 列表",
    "wysiwyg.numberedListLabel": "1. 列表",
    "wysiwyg.clearFormattingLabel": "⌫ 清除",

    // --- main.ts fatal startup overlay --------------------------------------------------------------------
    "main.fatal.heading": "SoundCheckBox 启动失败",
    "main.fatal.hint": "请将此文本发送给技术支持 — 它能帮助精确定位问题。",
    "main.fatal.userAgentLabel": "User agent: {ua}",

    // --- editor tour & cheatsheet (components/editor-tour.ts) ---------------------------------------------
    "tour.buttonTitle": "交互式导览与帮助 (?)",
    "tour.buttonLabel": "帮助",
    "tour.stepBadge": "第 {current} 步，共 {total} 步",
    "tour.closeAriaLabel": "关闭",
    "tour.prev": "← 上一步",
    "tour.next": "下一步 →",
    "tour.finish": "完成",
    "tour.cheatSheetButton": "快捷键指南",
    "tour.cheatSheetButtonTitle": "查看完整的键盘快捷键和修饰键指南",
    "tour.cheatSheetTitle": "编辑器快捷键与修饰键",
    "tour.startTourButton": "开始导览",
    "tour.closeSheetButton": "关闭",

    "tour.steps.stageSize.title": "1. 更改舞台尺寸",
    "tour.steps.stageSize.desc": "双击舞台地面（触屏设备请轻点两下）。拖动边和角上的控制点来设定舞台的宽度和深度；左上角显示以米为单位的尺寸。点击 <b>完成</b> 或按 <b>Enter</b>。",
    "tour.steps.addObject.title": "2. 添加乐手和设备",
    "tour.steps.addObject.desc": "在底部选择一个标签（<b>members</b> 是乐手，<b>Drums &amp; Perc</b>、<b>mic &amp; DI</b>、<b>monitors</b>、<b>backline</b>…）。点击预设或把它拖到舞台上，再拖到该放的位置。",
    "tour.steps.addObject.iem": "有些乐手更喜欢入耳监听。",
    "tour.steps.addObject.outputs": "<b>Output List</b> 会自动重新计算。",
    "tour.steps.members.title": "3. 乐手和他们的设备",
    "tour.steps.members.desc": "乐手（<b>members</b>）是预设的基础：乐器、话筒和 DI 都随乐手一起带入。有时在舞台上只看设备更方便：按住 <b>Alt</b> 点击乐手，再按 <b>Delete</b> — 设备会留下。",
    "tour.steps.arrange.title": "4. 布置舞台",
    "tour.steps.arrange.desc": "把物件拖到位。<b>旋转</b> 会显示一个圆环：拖动它转动所选物件。点 <b>绑定对象</b>，再点击台子（riser）或支架，物件就会固定在上面，一起移动。<b>整叠</b> / <b>单件</b> 决定点击选中的是什么。手势见 <b>快捷键指南</b>。设备与舞台结构之间的相对位置，有时在 <b>俯视图</b> 里更容易微调。",
    "tour.steps.channels.title": "5. Input List 和 Output List",
    "tour.steps.channels.desc": "<b>Input List</b> 和 <b>Output List</b> 会根据舞台上的物件自动生成；只需在 <b>音源</b> 列填入乐手的名字。拖动一行即可更改它的 <b>通道</b>。给每路返听混音写上去向：在 <b>音源</b> 中填写每个返听是为谁摆放的。",
    "tour.steps.micDi.title": "6. 话筒和 DI",
    "tour.steps.micDi.desc": "话筒和 DI 随预设一起带入。点击某一行的 <b>话筒 / DI</b> 单元格，在下拉列表中选择您偏好的型号。",
    "tour.steps.planSheet.title": "7. 检查平面图",
    "tour.steps.planSheet.desc": "切换到 <b>平面图</b>，看看您的 Rider 以图纸形式是什么样：舞台上的技术人员看到的就是这个。在这里也可以移动物件。",
    "tour.steps.riderFill.title": "8. 填写 Rider 并保存",
    "tour.steps.riderFill.desc": "在右侧 <b>Rider</b> 标签中：写好 <b>Rider 文本说明</b> 和需要的备注，填入 Rider 的 <b>名称</b> 和 <b>乐队名称</b>，添加 <b>Logo 文件</b>。然后点击顶部的 <b>保存 Rider 至数据库</b>。",
    "tour.steps.publishPrint.title": "9. 发布与打印",
    "tour.steps.publishPrint.desc": "Rider 保存后，<b>发布 Rider</b> 会生成一个给场地的只读链接并复制它。<b>PDF</b> 会询问 <b>要打印什么？</b>：<b>Simple View</b>、<b>Tech stage plot</b> 或 <b>两页</b>；<b>打印全部</b> 会打开带预览的 <b>打印设置</b>。",
    "tour.end.title": "清空舞台还是继续？",
    "tour.end.desc": "导览在舞台上放置了设备。要清空舞台，还是继续使用这个舞台？",
    "tour.end.clean": "清空舞台",
    "tour.end.keep": "继续使用这个舞台",
    "tour.banner.text": "第一次来？看一个简短的导览：程序会在舞台上演示每一步。",
    "tour.banner.start": "开始导览",
    "tour.banner.close": "关闭",

    "tour.cs.sectionNav": "3D 导航",
    "tour.cs.dragOrbit": "旋转相机视角",
    "tour.cs.dragPan": "平移舞台视角",
    "tour.cs.zoom": "放大 / 缩小",
    "tour.cs.topView": "切换俯视图 / 3D",

    "tour.cs.sectionModifiers": "手势与修饰键",
    "tour.cs.clickDefault": "选择并移动整个分组或地台",
    "tour.cs.altClick": "单独选择分组内的单个对象",
    "tour.cs.altDrag": "单独移动对象而不移动分组",
    "tour.cs.shiftGlue": "将拖拽对象吸附到目标对象",
    "tour.cs.altShiftDetach": "将对象从分组中原地解绑",
    "tour.cs.rotateGizmo": "旋转分组 (Alt 单独旋转对象)",

    "tour.cs.sectionObjectOps": "对象操作",
    "tour.cs.opProperties": "打开对象参数与音频通道",
    "tour.cs.opRotate": "启用交互式旋转环",
    "tour.cs.opAttach": "绑定选中对象到另一个对象",
    "tour.cs.opSavePreset": "将分组保存为用户预设",
    "tour.cs.opDelete": "仅删除当前对象（保留子级）",
    "tour.cs.opDeleteTree": "删除对象及其所有子级",

    "tour.cs.sectionHotkeys": "快捷键",
    "tour.cs.keyProperties": "显示 / 隐藏对象属性",
    "tour.cs.keyRotate": "切换旋转控制环",
    "tour.cs.keyInputList": "显示 / 隐藏输入表 (Input List)",
    "tour.cs.keyOutputList": "显示 / 隐藏输出表 (Output List)",
    "tour.cs.keyUndo": "撤销操作",
    "tour.cs.keyRedo": "重做操作",
    "tour.cs.keySave": "保存演出要求",
    "tour.cs.keyEscape": "取消选择 / 关闭对话框",
    "sideNav.shows": "演出",
    "shows.pageTitle": "演出",
    "shows.tab.inbox": "收件箱",
    "shows.tab.calendar": "日历",
    "shows.tabsLabel": "演出分区",
    "shows.tab.list": "演出",
    "shows.list.label": "全部演出",
    "shows.list.col.date": "日期",
    "shows.list.col.band": "乐队",
    "shows.list.col.venue": "场地",
    "shows.list.col.city": "城市",
    "shows.list.col.rental": "租赁",
    "shows.list.col.status": "状态",
    "shows.list.empty": "还没有演出。",
    "shows.list.emptyFiltered": "此筛选下没有演出。",
    "shows.list.rentalOne": "1 个报价",
    "shows.list.rentalMany": "{n} 个报价",
    "shows.list.rentalNone": "暂无报价",
    "shows.list.rentalYou": "您",
    "shows.list.dateOpen": "日期未定",
    "shows.list.state.sketch": "草稿",
    "shows.mcal.label": "演出日历",
    "shows.mcal.prev": "上个月",
    "shows.mcal.next": "下个月",
    "shows.mcal.showAll": "显示全部",
    "shows.mcal.filterDay": "{day}的演出",
    "shows.mcal.filterMonth": "{month}的演出",
    "shows.mcal.today": "今天",
    "shows.loadFailed": "无法加载你的演出：{error}",
    "shows.inbox.empty": "目前没有需要你处理的事项。",
    "shows.inbox.listLabel": "需要你处理的事项",
    "shows.inbox.unknownWho": "一位供应商",
    "shows.inbox.approvalNew": "{who} 为 {subject}（{when}） 提交了报价，等待你的批准。",
    "shows.inbox.approvalAgain": "{who} 重新提交了 {subject}（{when}） 的报价，等待你的批准。",
    "shows.inbox.newOffer": "{who} 为 {subject}（{when}） 提交了报价。",
    "shows.inbox.reconfirm": "演出要求已更改（v{from} 到 v{to}）。请重新确认你对 {subject}（{when}） 的报价。",
    "shows.inbox.declined": "你对 {subject}（{when}） 的报价被拒绝了。",
    "shows.inbox.declinedReason": "原因：{reason}",
    "shows.inbox.riderRequest": "{subject}（{when}） 请求提供演出要求。",
    "shows.inbox.open": "打开",
    "shows.inbox.dateOpen": "日期尚未确定",
    "shows.inbox.received": "收到时间：{at}",
    "shows.inbox.new": "新",
    "sideNav.unreadCount": "{n} 条未读",
    "shows.cal.month": "月",
    "shows.cal.week": "周",
    "shows.cal.list": "列表",
    "shows.cal.today": "今天",
    "shows.cal.prev": "上一个",
    "shows.cal.next": "下一个",
    "shows.cal.noEvents": "此时间段没有演出",
    "shows.cal.waiting": "等待日期",
    "shows.cal.waitingHint": "尚无日期的演出不在日历格中。",
    "shows.cal.waitingEmpty": "没有等待日期的演出。",
    "shows.cal.sketch": "草稿",
    "shows.cal.untitled": "未命名演出",
    "shows.feed.title": "在你的日历中订阅",
    "shows.feed.hint": "Google、Apple 和 Outlook 日历可通过“按 URL 订阅”使用此地址。",
    "shows.feed.hidden": "你的链接已开启。出于安全考虑，它只在创建时显示——重新生成即可获得新链接。",
    "shows.feed.addressLabel": "你的私人日历地址",
    "shows.feed.create": "创建链接",
    "shows.feed.rotate": "重新生成",
    "shows.feed.rotateConfirm": "再点一次：旧链接将失效",
    "shows.feed.turnOff": "关闭",
    "shows.feed.turnOffConfirm": "再点一次以关闭",
    "shows.feed.failed": "无法更新日历链接：{error}",
    "shows.detail.back": "演出",
    "shows.detail.loadFailed": "无法读取此演出：{error}",
    "shows.detail.state.open": "开放",
    "shows.detail.state.waiting": "等待报价",
    "shows.detail.state.offers_in": "已收到报价",
    "shows.detail.state.agreed": "已确认",
    "shows.detail.state.past": "已结束",
    "shows.detail.acts": "演出节目",
    "shows.detail.noActs": "此演出尚无艺人。",
    "shows.detail.riderVersion": "演出要求 v{version}",
    "shows.detail.noRider": "尚无演出要求",
    "shows.detail.newerVersion": "有更新的版本：v{version}",
    "shows.detail.getLink": "显示演出链接",
    "shows.detail.linkFailed": "无法获取链接：{error}",
    "shows.detail.sketchTitle": "草稿——尚无日期和场地",
    "shows.detail.sketchHint": "设置日期或场地后，它就成为普通演出。",
    "shows.detail.sketchWhere": "日期与场地",
    "shows.detail.change": "更改日期和场地",
    "shows.detail.changeNeedsDate": "请选择日期：该演出已有日期。",
    "shows.detail.sketchSave": "保存日期和场地",
    "shows.detail.sketchNeeds": "请先选择日期或场地。",
    "shows.detail.saveFailed": "无法保存：{error}",
    "shows.offers.heading": "报价",
    "shows.offers.empty": "暂无报价。",
    "shows.offers.sortLabel": "排序",
    "shows.offers.sort.time": "时间（提交）",
    "shows.offers.sort.match": "匹配",
    "shows.offers.sort.fewestMissing": "缺项最少",
    "shows.offers.sort.price": "价格",
    "shows.offers.sort.priceNotYet": "暂未提供",
    "shows.offers.match": "{n} 项匹配",
    "shows.offers.missing": "缺 {n} 项",
    "shows.offers.riderChanged": "演出要求已更改 v{from} → v{to}",
    "shows.offers.open": "打开报价",
    "shows.offers.organiserApprove": "以主办方身份批准",
    "shows.offers.organiserRequestChanges": "以主办方身份要求修改",
    "shows.offers.actionFailed": "无法完成：{error}",
    // --- crew: the hired worker's screen and the admin's test link (SCRUM-762) ---
    "crew.untitledShow": "演出",
    "crew.dateOpen": "日期未定",
    "crew.venueNone": "场地未定",
    "crew.signInWhy": "这是一份演出工作。请登录或注册账号来接单，只需一分钟。",
    "crew.signInToTake": "登录后接下这份工作",
    "crew.take": "接下这份工作",
    "crew.takenBySomeone": "这份工作已被别人接走。请向发给你链接的人再要一个属于你的链接。",
    "crew.gone": "此工作链接不存在或已被撤回。",
    "crew.failed": "出错了：{error}",
    "crew.saveFailed": "勾选未保存：{error}",
    "crew.noRider": "这场演出还没有已发布的 Rider，没有可勾选的内容。",
    "crew.riderGone": "该演出的技术需求单已不再发布，因此清单为空。步骤仍保留。",
    "crew.riderMoved": "本场演出确认后技术文件已更新——以下清单为新版。",
    "crew.riderMovedOn": "技术文件于 {date} 更新，比本场演出确认的版本更新。以下清单为新版。",
    "crew.tab.out": "备货",
    "crew.tab.venue": "场地",
    "crew.tab.return": "归还",
    "crew.tab.plan": "计划",
    "crew.time.warehouse": "仓库",
    "crew.time.truck": "货车",
    "crew.time.venue": "场地",
    "crew.time.showRun": "演出",
    "crew.time.strike": "撤场",
    "crew.thisPart": "本部分",
    "crew.doneOf": "{done}/{total}",
    "crew.done": "完成",
    "crew.twoPeople": "需两人搬运",
    "crew.showRunTwo": "2 人",
    "crew.kit.inside": "内含",
    "crew.kit.cablesApart": "线缆在「线缆」区块中计数",
    "crew.kit.included": "盒内附带",
    "crew.kit.consumablesApart": "电池等耗材单独一行计数",
    "crew.truckFront": "车厢前部",
    "crew.missing": "缺失",
    "crew.broken": "损坏",
    "crew.missingOpen": "缺失——保持未结",
    "crew.brokenOpen": "损坏——保持未结",
    "crew.less": "减一",
    "crew.more": "加一",
    "crew.tickAria": "{name}：{done}/{total}",
    "crew.hint.fromOffer": "不在此 Rider 中，来自租赁方的报价",
    "crew.hint.nothing": "这里没有内容",
    "crew.returnOpen": "还有 {n} 行未结（未归还、缺失或损坏）。它们仍保留在租赁清单中，不会消失。",
    "crew.returnAllBack": "全部已归还。",
    // SCRUM-760: «Loading done — depart» gate. Translated like the neighbouring crew.* keys.
    "crew.gate.depart": "装车完毕——出发",
    "crew.gate.departVenue": "装车完毕——离开场地",
    "crew.gate.confirm": "货车现在出发？再按一次",
    "crew.gate.waiting": "等待司机发车",
    "crew.gate.departed": "已于 {time} 出发 · {name}",
    "crew.gate.departedNoName": "已于 {time} 出发",
    "crew.gate.by.driver": "由司机发车",
    "crew.gate.by.supplier": "由租赁公司发车",
    "crew.gate.locked": "货车已离开，装车已关闭。如有遗漏，请让司机重新开放装车。",
    "crew.gate.next": "继续 — {tab}",
    "crew.gate.reopen": "重新开放装车",
    "crew.gate.failed": "无法更新发车状态：{error}",
    "crew.zoom": "缩放",
    "crew.fit": "适应",
    "crew.legendDone": "完成 {n}",
    "crew.legendPart": "部分 {n}",
    "crew.legendTodo": "待办 {n}",
    "crew.legendMiss": "缺失 / 损坏 {n}",
    "crew.planHint": "勾选按区块进行；计划按层显示，顺序与当天流程一致。",
    "crew.changeover.title": "演出之间的换场",
    "crew.changeover.heading": "换场 {from} → {to}",
    "crew.changeover.headingMin": "换场 {from} → {to}（{n} 分钟）",
    "crew.changeover.none": "无需搬动：下一场需要的东西已在原位。",
    "crew.changeover.recheck": "之后检查线路，通道：{channels}",
    "crew.zone.USR": "舞台后部右侧",
    "crew.zone.USC": "舞台后部中间",
    "crew.zone.USL": "舞台后部左侧",
    "crew.zone.SR": "舞台右侧",
    "crew.zone.CS": "舞台中央",
    "crew.zone.SL": "舞台左侧",
    "crew.zone.DSR": "舞台前部右侧",
    "crew.zone.DSC": "舞台前部中间",
    "crew.zone.DSL": "舞台前部左侧",
    "crew.step.toWingsStand": "把{item}连同支架移到侧台，线缆不拔",
    "crew.step.rollOut": "把{item}推到侧台",
    "crew.step.back": "把{item}从侧台取回",
    "crew.step.swapStand": "取下{from}，在同一支架上装{to}",
    "crew.step.replace": "把{from}换成{to}",
    "crew.step.add": "架设{item}",
    "crew.step.bandOut": "从舞台撤走{act}的设备：{items}",
    "crew.step.bandIn": "架设{act}的设备：{items}",
    "crew.layer.picked": "已备货",
    "crew.layer.loaded": "已装车",
    "crew.layer.placed": "已摆放",
    "crew.layer.patched": "已接线",
    "crew.layer.checked": "已检查",
    "crew.layer.unpatched": "已拆线",
    "crew.layer.struck": "已撤场",
    "crew.layer.loadedback": "已装回",
    "crew.layer.returned": "已归还",
    "crew.phase.pick": "仓库备货",
    "crew.phase.pickSub": "按卸货顺序备货——装车顺序相反",
    "crew.phase.load": "装车",
    "crew.phase.loadSub": "倒序装车 · 重物靠车厢前部",
    "crew.phase.setup": "卸货与搭建",
    "crew.phase.setupSub": "在场地",
    "crew.phase.showRun": "演出",
    "crew.phase.showRunSub": "人员保持待命——舞台任务稍后提供",
    "crew.phase.strike": "撤场与装车",
    "crew.phase.strikeSub": "演出结束后",
    "crew.phase.back": "返回仓库",
    "crew.phase.backSub": "卸货并登记——哪些已归还、哪些缺失、哪些损坏",
    "crew.block.carts": "推车与坡道",
    "crew.block.racks": "机架与供电",
    "crew.block.pa": "P.A.",
    "crew.block.mon": "监听",
    "crew.block.foh": "FOH",
    "crew.block.mics": "话筒",
    "crew.block.dis": "DI",
    "crew.block.stands": "支架",
    "crew.block.backline": "Backline",
    "crew.block.risers": "升降台与家具",
    "crew.block.cables": "线缆",
    "crew.block.other": "其他",
    "crew.block.loadOut": "装车 · {block}",
    "crew.block.unloadToPositions": "卸货到位",
    "crew.block.unloadToPositionsSub": "重物直接就位，FOH 到其位置",
    "crew.block.paMonitorsInPlace": "P.A. 与监听就位",
    "crew.block.powerPa": "P.A. 供电",
    "crew.block.powerStage": "舞台供电",
    "crew.block.powerFoh": "FOH 供电",
    "crew.block.paCheck": "P.A. 检查与前补声",
    "crew.block.stageSet": "按 Rider 布置舞台",
    "crew.block.stageSetSub": "与 P.A. 检查同时进行",
    "crew.block.patch": "接线",
    "crew.block.patchSub": "输入清单中的每一路输入",
    "crew.block.lineCheck": "Line check",
    "crew.block.lineCheckSub": "乐队的调音师到场并开始声音检查",
    "crew.block.showRun": "演出",
    "crew.block.showRunSub": "演出期间在舞台上",
    "crew.block.showRunN": "演出 {n}",
    "crew.banner.powerOn": "开机：先开信号源（调音台、舞台机柜、无线系统），再开功放。",
    "crew.banner.powerOff": "关机：先关功放，再关信号源（调音台、舞台机柜、无线系统）。",
    "crew.block.unpatch": "拆线",
    "crew.block.clearSmall": "清台 · 小件、轻件与线缆",
    "crew.block.clearSmallSub": "先收话筒、DI、支架和线缆",
    "crew.block.clearLarge": "清台 · 大件",
    "crew.block.clearLargeSub": "音箱、升降台、钢琴、监听",
    "crew.block.fohPaLast": "FOH 与 P.A.",
    "crew.block.fohPaLastSub": "最后撤——搭建时最先到位",
    "admin.crew.title": "给自己的工作人员链接（测试）",
    "admin.crew.hint": "把你加为你名下某场演出的工作人员，以便在手机上试用工作人员界面。在手机上打开链接并接下工作。",
    "admin.crew.show": "演出",
    "admin.crew.make": "生成工作人员链接",
    "admin.crew.made": "链接已生成。请在手机上打开。",
    "admin.crew.link": "工作人员链接",
    "admin.crew.open": "打开",
    "admin.crew.noShows": "你还没有演出——请先在“演出”中创建一场",
    "admin.crew.dateOpen": "无日期",
    "admin.crew.failed": "无法完成：{error}",
    "admin.perf.title": "给演出添加一场表演",
    "admin.perf.hint": "这样它就成了多场演出：团队链接的场地页会显示各场之间的换场。使用上面选中的演出。",
    "admin.perf.name": "表演名称",
    "admin.perf.rider": "Rider（已发布）",
    "admin.perf.noRider": "暂无 rider",
    "admin.perf.add": "添加表演",
    "admin.perf.added": "已添加。该演出现有 {n} 场。",
    "admin.perf.failed": "无法添加：{error}",
    "admin.perf.needName": "请给这场表演起个名字",

    // --- rental desk (rental/desk-answer-panel.ts, rental/desk-shows-panel.ts, pages/warehouse-tabs.ts, SCRUM-647) ---
    "rental.tabsLabel": "设备仓库分区",
    "rental.loadFailed": "加载失败：{error}",
    "rental.toAnswer.heading": "待回复",
    "rental.toAnswer.empty": "没有待办——所有报价都已回复。",
    "rental.cover.positions": "{n} 个条目",
    "rental.cover.positionsOne": "{n} 个条目",
    "rental.cover.ok": "{n} 项来自你的仓库",
    "rental.cover.short": "{n} 项数量不足",
    "rental.cover.missing": "{n} 项缺少",
    "rental.cover.answered": "已回答 {n}",
    "rental.cover.emptyWarehouse": "你的仓库是空的——添加设备即可查看覆盖情况",
    "rental.reason.draft": "尚未发送",
    "rental.reason.changes": "对方要求修改",
    "rental.reason.reconfirm": "Rider 已更改——请重新确认",
    "rental.shows.heading": "我的演出",
    "rental.shows.empty": "还没有演出。为某个日期发送报价后，演出会出现在这里。",
    "rental.shows.dateOpen": "日期未定",
    "rental.shows.venueNone": "场地未定",
    "rental.shows.myOffer": "我的报价：{status}",
    "rental.crew.make": "工作人员链接",
    "rental.crew.making": "正在创建…",
    "rental.crew.newLink": "新的工作人员链接——发给工作人员",
    "rental.crew.linksHeading": "工作人员链接",
    "rental.crew.free": "尚无人接手",
    "rental.crew.takenBy": "接手人：{name}",
    "rental.crew.taken": "已接手",
    "rental.crew.failed": "操作失败：{error}",
    "rental.crew.withdraw": "撤回",
    "rental.crew.withdrawSure": "撤回？再按一次",
    "rental.crew.withdrawFailed": "无法撤回链接：{error}",
    // SCRUM-760: driver link, role on a link row, the departure line. Translated like the neighbouring rental.crew.* keys.
    "rental.crew.driver": "司机链接",
    "rental.crew.role.crew": "工作人员",
    "rental.crew.role.driver": "司机",
    "rental.crew.takeMyself": "我自己来",
    "rental.crew.takenByYou": "你已接手",
    "rental.crew.openMine": "打开",
    "rental.depart.out": "已离开仓库",
    "rental.depart.venue": "已离开场地",
    "rental.depart.reopen": "重新开放装车",
    "rental.depart.failed": "无法更新发车状态：{error}",
    "rental.progress.heading": "工作进度",
    "rental.tasks.heading": "现场团队做什么",
    "rental.tasks.blocks": "{n} 个区块",
    "rental.tasks.template": "我们的工作顺序",
    "rental.tasks.templateNote": "每场演出都是同样的步骤。具体某场演出会补上数量——按技术需求单要取什么、接什么、测什么。",
    "rental.progress.doneOf": "{done} / {total}",
    "rental.progress.noLinks": "还没有工作人员链接——工作人员开始勾选后会显示进度。",
    "rental.progress.noRider": "此演出没有已发布的 rider——只计算步骤。",
    "rental.progress.failed": "进度加载失败：{error}",
};